import React, { useState, useEffect } from 'react';
import { Alert, Accordion, Card, Button, Form, Modal, OverlayTrigger, Popover, Table, Tabs, Tab, ListGroup } from 'react-bootstrap'
import { AccordionToggle, AccordionCollapse} from './AccordionCompat';
import Select from 'react-select';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Moment from 'moment';
import { addDays, addYears } from 'date-fns'
import SHA256 from "crypto-js/sha256";
import CurrencyInput from 'react-currency-input-field';
import DatePicker from 'react-datepicker';
import { isEmpty } from 'lodash';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Sticky from 'react-sticky-el';

export default (props) => {
    let query = new URLSearchParams(useNavigate().search);
    const [activeId, setActiveId] = useState(query.get("paymentID") === null ? 'basic' : query.get("keyTab"));
    const [basicInfo, setBasicInfo] = useState({});
    const [valuableInfo, setValuableInfo] = useState([]);
    const [claimInfo, setClaimInfo] = useState({});
    const [comparisonInfo, setComparisonInfo] = useState({});
    const [additionalInfo, setAdditionalInfo] = useState({});
    const [personalInfo, setPersonalInfo] = useState([]);
    const [steps] = useState(['basic', 'quote', 'addtl', 'valuable', 'personal', 'payment']);

useEffect(() => {
    //console.log('Referral from App.js:', props.referral);
}, [props.referral]);

    return (
        <section id="body">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="row text-center steps bg-white shadow">
                            <div className="col-12 px-0 px-sm-auto">
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('basic') ? ' ' : 'opacity-25 ') + "d-inline-block position-relative pt-5 align-text-top step first"} onClick={() => { steps.indexOf(activeId) > steps.indexOf('basic') ? setActiveId('basic') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('basic') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">1</h4>
                                    </div>
                                    <div className={(activeId == 'basic' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center description"}>Info</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('quote') ? '' : 'opacity-25 ') + "d-inline-block position-relative pt-5 align-text-top step"} onClick={() => { steps.indexOf(activeId) > steps.indexOf('quote') ? setActiveId('quote') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('quote') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">2</h4>
                                    </div>
                                    <div className={(activeId == 'quote' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center description"}>Plan</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('addtl') ? '' : 'opacity-25 ') + "d-inline-block position-relative pt-5 align-text-top step"} onClick={() => { steps.indexOf(activeId) > steps.indexOf('addtl') ? setActiveId('addtl') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('addtl') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">3</h4>
                                    </div>
                                    <div className={(activeId == 'addtl' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center description"}>Add Ons</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('valuable') ? '' : 'opacity-25 ') + "d-inline-block position-relative pt-5 align-text-top step"} onClick={() => { steps.indexOf(activeId) > steps.indexOf('valuable') ? setActiveId('valuable') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('valuable') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">4</h4>
                                    </div>
                                    <div className={(activeId == 'valuable' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center description"}>Valuables</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('personal') ? ' ' : 'opacity-25 ') + "d-inline-block position-relative pt-5 align-text-top step"} onClick={() => { steps.indexOf(activeId) > steps.indexOf('personal') ? setActiveId('personal') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('personal') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">5</h4>
                                    </div>
                                    <div className={(activeId == 'personal' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center description"}>Details</div>
                                </div>
                                <div className={(steps.indexOf(activeId) >= steps.indexOf('payment') ? ' ' : 'opacity-25 ') + "d-inline-block position-relative pt-5 align-text-top step last"} onClick={() => { steps.indexOf(activeId) > steps.indexOf('payment') ? setActiveId('payment') : null }}>
                                    <div className={(steps.indexOf(activeId) >= steps.indexOf('payment') ? 'bg-secondary clickable' : 'bg-primary') + " d-block text-white position-absolute border rounded-circle text-center px-1 order"}>
                                        <h4 className="fw-bold text-white mb-0">6</h4>
                                    </div>
                                    <div className={(activeId == 'payment' ? 'text-primary text-nowrap d-block' : 'd-none') + " text-center description"}>Payment</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-12">
                        <div className="row content">
                            <div className="col-1"></div>
                            <div className="col-10 shadow bg-white rounded p-5">
                                <Tabs activeKey={activeId} variant="tabs">
                                    <Tab eventKey="basic">
                                        <Basic setActiveId={setActiveId} setBasicInfo={setBasicInfo} setClaimInfo={setClaimInfo} basicName={props.basicName} basicEmailAdd={props.basicEmailAdd} basicContactNo={props.basicContactNo} />
                                    </Tab>
                                    <Tab eventKey="quote">
                                        <Quote setActiveId={setActiveId} setComparisonInfo={setComparisonInfo} basicInfo={basicInfo} activeId={activeId} />
                                    </Tab>
                                    <Tab eventKey="addtl">
                                        <Additional setActiveId={setActiveId} setAdditionalInfo={setAdditionalInfo} basicInfo={basicInfo} comparisonInfo={comparisonInfo} activeId={activeId} />
                                    </Tab>
                                    <Tab eventKey="valuable">
                                        <Valuable setActiveId={setActiveId} setValuableInfo={setValuableInfo} basicInfo={basicInfo} basicCntMItems={basicInfo.basicCntMItems} />
                                    </Tab>
                                    <Tab eventKey="personal">
                                        <Personal setActiveId={setActiveId} setPersonalInfo={setPersonalInfo} basicInfo={basicInfo} comparisonInfo={comparisonInfo} additionalInfo={additionalInfo} />
                                    </Tab>
                                    <Tab eventKey="payment">
                                        <Payment setActiveId={setActiveId} basicInfo={basicInfo} valuableInfo={valuableInfo} claimInfo={claimInfo} comparisonInfo={comparisonInfo} additionalInfo={additionalInfo} personalInfo={personalInfo} referral={props.referral} />
                                    </Tab>
                                </Tabs>
                            </div>
                            <div className="col-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function Basic(props) {
    const [basicName] = useState(props.basicName);
    const [basicContactNo] = useState(props.basicContactNo);
    const [basicEmailAdd] = useState(props.basicEmailAdd);
    const [basicType, setBasicType] = useState("");
    const [bldgType, setBldgType] = useState("");
    const [protectType, setProtectType] = useState("");
    const [constType, setConstType] = useState("");
    const [basicStartDate, setBasicStartDate] = useState(new Date());
    const [basicEndDate, setBasicEndDate] = useState(addDays(addYears(new Date(), 1), -1));
    const [basicStorey, setBasicStorey] = useState("");
    const [basicStoreyList] = useState([
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" }
    ]);
    // const [basicGrossArea, setBasicGrossArea] = useState("");
    // const [basicGrossAreaList, setBasicGrossAreaList] = useState([]);
    const [basicBldgAmt, setBasicBldgAmt] = useState("");
    const [basicContentAmt, setBasicContentAmt] = useState("");
    const [basictotalSI, setBasictotalSI] = useState("");
    const [basicCntLiving, setBasicCntLiving] = useState("");
    const [basicCntBedroom, setBasicCntBedroom] = useState("");
    const [basicCntDining, setBasicCntDining] = useState("");
    const [basicCntKitchen, setBasicCntKitchen] = useState("");
    const [basicCntBath, setBasicCntBath] = useState("");
    const [basicCntStore, setBasicCntStore] = useState("");
    const [basicCntGarage, setBasicCntGarage] = useState("");
    const [basicCntMItems, setBasicCntMItems] = useState("");
    const [basicCntTotal, setBasicCntTotal] = useState("");
    const [hasError, setHasError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [eligible, setEligible] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [showClaimModal, setShowClaimModal] = useState(false);
    let myDivToFocus = React.createRef();
    const swalAlert = withReactContent(Swal);
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: currentYear - 1800 }, (_, index) => currentYear - index);

    const [selectedYear, setSelectedYear] = useState('');
    const [buildingAge, setBuildingAge] = useState('');

    const calculateAge = (selectedYear) => {
        if (selectedYear !== '') {
            const age = currentYear - selectedYear;
            return age;
        }
        return '';
    };

    const handleYearChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedYear(selectedValue);
        const age = calculateAge(selectedValue);
        setBuildingAge(age);
    };

    // useEffect(() => {
    //     swalAlert.fire({
    //         title: 'Please Wait...',
    //         allowOutsideClick: false
    //     });

    //     swalAlert.showLoading();

    //     if (basicGrossAreaList.length === 0) {
    //         axios.get('/api/grossfloorarea')
    //             .then(response => {
    //                 setBasicGrossAreaList(response.data);
    //                 swalAlert.close();
    //             })
    //     }
    // }, []);

    useEffect(() => {
        var totalSI = (!basicBldgAmt ? 0 : parseFloat(basicBldgAmt)) + (!basicContentAmt ? 0 : parseFloat(basicContentAmt));

        setBasictotalSI(totalSI == 0 ? "" : parseFloat(totalSI).toFixed(2));
    }, [basicBldgAmt, basicContentAmt]);

    useEffect(() => {
        if (!eligible) {
            let data = {
                name: basicName,
                contact_no: basicContactNo,
                email_address: basicEmailAdd,
                is_owner: basicType === "owner",
                building_type: bldgType,
                const_type: constType,
                protect_type: protectType,
                number_of_storeys: basicStorey,
                //gross_floor_area: basicGrossArea,
                building_amount: basicBldgAmt,
                content_amount: basicContentAmt,
                year_construction: selectedYear,
                age_building: buildingAge
            }

            rejectedCasesMail(data);

            swalAlert.fire({
                title: 'Yay!',
                icon: 'success',
                text: `Thank you for showing interest in the home insurance. We will be reaching out to you shortly!`
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }, [eligible]);

    function checkSumInsuredAmount() {
        console.log(basicBldgAmt);
        console.log(basicContentAmt);
        if ((protectType === 'building' || protectType === 'building&content') && (parseFloat(basicBldgAmt) < 19999 || parseFloat(basicBldgAmt) > 10000001)) {
            swalAlert.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please take note on the minimum and maximum limit of Sum Insured on the insurance coverage wish to purchase: - Building- Min- RM20,000.00, Max- RM10,000,000.00.',
            }).then((result) => {
                if (result.isConfirmed) {
                    setBasicBldgAmt("");
                }
            });
        }

        if ((protectType === 'content' || protectType === 'building&content') && (parseFloat(basicContentAmt) <= 19999 || parseFloat(basicContentAmt) >= 300001)) {
            swalAlert.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please take note on the minimum and maximum limit of Sum Insured on the insurance coverage wish to purchase: - Content- Min- RM20,000.00, Max- RM300,000.00',
            }).then((result) => {
                if (result.isConfirmed) {
                    setBasicContentAmt("");
                }
            });
        }
    }

    function onClickNext(e) {
        const form = e.currentTarget;

        if (form.checkValidity() !== false) {
            e.preventDefault();
            e.stopPropagation();

            if ((basicType == "" || constType == "" || bldgType == "" ||  protectType == "")
                || (bldgType == "landed" && basicStorey == "") || (protectType == "building" && basicBldgAmt == "")
                || (protectType == "content" && basicContentAmt == "") ||
                (protectType == "building&content" && basicBldgAmt == "" && basicContentAmt == "")) {
                setHasError(true);
                setErrorMsg("Kindly provide all information.");

                if (myDivToFocus.current) {
                    myDivToFocus.current.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                    });
                    setTimeout(function () {
                        setHasError(false)
                    }.bind(this), 5000);
                }
            } else {
                if ((protectType === 'building' || protectType === 'building&content') && (parseFloat(basicBldgAmt) < 19999 || parseFloat(basicBldgAmt) > 10000001)) {
                    swalAlert.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Please take note on the minimum and maximum limit of Sum Insured on the insurance coverage wish to purchase: - Building- Min- RM20,000.00, Max- RM10,000,000.00.',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setBasicBldgAmt("");
                        }
                    });
                    setShowClaimModal(false); // Add this line to hide the modal
                    return; // Return early to prevent further execution
                }
    
                if ((protectType === 'content' || protectType === 'building&content') && (parseFloat(basicContentAmt) <= 19999 || parseFloat(basicContentAmt) >= 300001)) {
                    swalAlert.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Please take note on the minimum and maximum limit of Sum Insured on the insurance coverage wish to purchase: - Content- Min- RM20,000.00, Max- RM300,000.00',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setBasicContentAmt("");
                        }
                    });
                    setShowClaimModal(false); // Add this line to hide the modal
                    return; // Return early to prevent further execution
                }

                props.setBasicInfo({
                    basicName: basicName,
                    basicContactNo: basicContactNo,
                    basicEmailAdd: basicEmailAdd,
                    basicType: basicType,
                    basicStartDate: basicStartDate,
                    basicEndDate: basicEndDate,
                    constType: constType,
                    bldgType: bldgType,
                    basicStorey: basicStorey,
                    protectType: protectType,
                    //basicGrossArea: basicGrossArea,
                    basicYearCons: selectedYear,
                    basicAge: buildingAge,
                    basicBldgAmt: basicBldgAmt,
                    basicContentAmt: basicContentAmt,
                    basictotalSI: basictotalSI,
                    basicCntLiving: basicCntLiving,
                    basicCntBedroom: basicCntBedroom,
                    basicCntDining: basicCntDining,
                    basicCntKitchen: basicCntKitchen,
                    basicCntBath: basicCntBath,
                    basicCntStore: basicCntStore,
                    basicCntGarage: basicCntGarage,
                    basicCntMItems: basicCntMItems,
                    basicCntTotal: basicCntTotal
                });

                setShowClaimModal(true);
            }
        }
    }

    function Claim(props) {
        const [claim, setClaim] = useState("");
        const [occupied, setOccupied] = useState("");
        const [rejected, setRejected] = useState("");
        const [incomplete, setIncomplete] = useState(false);
        const swalAlert = withReactContent(Swal);

        useEffect(() => {
            if (claim != "" && occupied != "" && rejected != "") {
                if ((claim == "No" && occupied == "No" && rejected == "No")){
                    props.setEligible(true);
                }else{
                    props.setEligible(false);
                    //props.setRejected(true);
    
                    swalAlert.fire({
                        title: 'Yay!',
                        icon: 'success',
                        text: 'Thank you for showing interest in the home insurance. We will be reaching out to you shortly!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.reload(false);
                        }
                    });
                }
            }
        }, [claim, occupied, rejected]);

        function onClickNext(e) {
            e.preventDefault();
            e.stopPropagation();

            if (claim == "" || occupied == "" || rejected == "") {
                setIncomplete(true);

                setTimeout(() => {
                    setIncomplete(false);
                }, 3000);
            } else if (claim != "" && occupied != "" && rejected != "") {
                props.setClaimInfo({
                    claim: claim,
                    occupied: occupied,
                    rejected: rejected
                });

                props.setShowClaimModal(false);
                props.setActiveId("quote");
            }
        }

        return (
            <Modal show={props.showClaimModal} onHide={() => { props.setShowClaimModal(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>
                        Do any of the following statements apply to you?
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {incomplete ?
                        <div className="row">
                            <div className="col-12">
                                <Alert variant="danger">Kindly provide all information.</Alert>
                            </div>
                        </div>
                        :
                        null
                    }
                    <Form onSubmit={(e) => onClickNext(e)}>
                        <div className="mb-3 row">
                            <label className="col-sm-7 col-form-label">I have claimed for loss or damage on this or other properties in the past two (2) years.</label>
                            <div className="col-sm-5">
                                <div className="mb-3 row">
                                    <div className="col-sm-6 d-grid">
                                        <Button
                                            type="button"
                                            variant={claim == "Yes" ? "info" : "border border-primary"}
                                            className="mb-3 mb-sm-0"
                                            onClick={() => { setClaim("Yes"); }}
                                        >
                                            YES
                                        </Button>
                                    </div>
                                    <div className="col-sm-6 d-grid">
                                        <Button
                                            
                                            type="button"
                                            variant={claim == "No" ? "info" : "border border-primary"}
                                            className="mb-3 mb-sm-0"
                                            onClick={() => { setClaim("No"); }}
                                        >
                                            NO
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-sm-7 col-form-label">This property will be unoccupied for 90 days or more.</label>
                            <div className="col-sm-5">
                                <div className="mb-3 row">
                                    <div className="col-sm-6 d-grid">
                                        <Button
                                            
                                            type="button"
                                            variant={occupied == "Yes" ? "info" : "border border-primary"}
                                            className="mb-3 mb-sm-0"
                                            onClick={() => { setOccupied("Yes"); }}
                                        >
                                            YES
                                        </Button>
                                    </div>
                                    <div className="col-sm-6 d-grid">
                                        <Button
                                            
                                            type="button"
                                            variant={occupied == "No" ? "info" : "border border-primary"}
                                            className="mb-3 mb-sm-0"
                                            onClick={() => { setOccupied("No"); }}
                                        >
                                            NO
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <label className="col-sm-7 col-form-label">
                                Has any insurer declined, cancelled, refused to renew insurance or increase your renewal premium?
                            </label>
                            <div className="col-sm-5">
                                <div className="mb-3 row">
                                    <div className="col-sm-6 d-grid">
                                        <Button
                                            
                                            type="button"
                                            variant={rejected == "Yes" ? "info" : "border border-primary"}
                                            className="mb-3 mb-sm-0"
                                            onClick={() => { setRejected("Yes"); }}
                                        >
                                            YES
                                        </Button>
                                    </div>
                                    <div className="col-sm-6 d-grid">
                                        <Button
                                            
                                            type="button"
                                            variant={rejected == "No" ? "info" : "border border-primary"}
                                            className="mb-3 mb-sm-0"
                                            onClick={() => { setRejected("No"); }}
                                        >
                                            NO
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mb-3 row mb-0">
                            <div className="col-12 text-end">
                                <Button type="submit" variant="success" disabled={!eligible}>Continue</Button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <Form onSubmit={(e) => onClickNext(e)}>
            <div className="mb-3 row" >
                <div className="col-12">
                    <Alert show={hasError} variant="danger">{errorMsg}</Alert>
                </div>
            </div>
            <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">I am</label>
                <div className="col-sm-8">
                    <div className="mb-3 row">
                        <div className="col-sm-6 d-grid">
                            <Button
                                type="button"
                                variant={basicType == "owner" ? "info" : "border border-primary"}
                                
                                className="mb-3 mb-sm-0"
                                onClick={() => { setBasicType("owner"); setProtectType("") }}
                            >
                                Own Stay
                            </Button>
                        </div>
                        <div className="col-sm-6 d-grid">
                            <Button
                                type="button"
                                variant={basicType == "tenant" ? "info" : "border border-primary"}
                                
                                className="mb-3 mb-sm-0"
                                onClick={() => { setBasicType("tenant"); setProtectType("content") }}
                            >
                                Rent Out
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">Coverage start</label>
                <div className="col-sm-8">
                    <div className="mb-3 row">
                        <label className="col-sm-2 col-form-label"><small>From</small></label>
                        <div className="col-sm-4">
                            <DatePicker
                                closeOnScroll={true}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={basicStartDate}
                                minDate={new Date()}
                                onChange={date => { setBasicStartDate(date); setBasicEndDate(addDays(addYears(date, 1), -1)); }}
                                required
                            />
                        </div>
                        <label className="col-sm-2 col-form-label text-center"><small>To</small></label>
                        <div className="col-sm-4">
                            <DatePicker
                                closeOnScroll={true}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                selected={basicEndDate}
                                disabled />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">Construction Type - FULL BRICKS ?
                    {/* <OverlayTrigger
                        trigger={['hover', 'click']}
                        key={"o1"}
                        placement="right"
                        overlay={
                            <Popover>
                                <Popover.Body>
                                    Full Brick:<br />Your home is made of solid bricks, cement and concrete floors.
                                    <br /><br />
                                    Partial Brick:<br />Your home wall is partly bricks, concrete and non-combustible materials and/or wholly of glass. Your roof is made of non-combustible materials.
                                </Popover.Body>
                            </Popover>
                        }
                    >
                        <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                    </OverlayTrigger> */}
                </label>
                <div className="col-sm-8">
                    <div className="mb-3 row">
                        <div className="col-sm-6 d-grid">
                            <Button
                                
                                type="button"
                                variant={constType == "Yes" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                onClick={() => { setConstType("Yes"); setEligible(true); }}
                            >
                                YES
                            </Button>
                        </div>
                        <div className="col-sm-6 d-grid">
                            <Button
                                
                                type="button"
                                variant={constType == "No" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                onClick={() => { setConstType("No"); setEligible(false); }}
                            >
                                NO
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">What type of building is it?
                    <OverlayTrigger
                        trigger={['hover', 'click']}
                        key={"o1"}
                        placement="right"
                        overlay={
                            <Popover id={`popover-positioned-right`}>
                                <Popover.Body>
                                    Landed:<br />Bungalow, Semi-Detached house, Terrace
                                    <br /><br />
                                    Non-Landed:<br />Apartment, condominium and Flats
                                </Popover.Body>
                            </Popover>
                        }
                    >
                        <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                    </OverlayTrigger>
                </label>
                <div className="col-sm-8">
                    <div className="mb-3 row">
                        <div className="col-sm-6 d-grid">
                            <Button
                                
                                type="button"
                                variant={bldgType == "landed" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                onClick={() => { setBldgType("landed"); setProtectType("") }}
                            >
                                Landed
                            </Button>
                        </div>
                        <div className="col-sm-6 d-grid">
                            <Button
                                type="button"
                                variant={bldgType == "non-landed" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                
                                onClick={() => { setBldgType("non-landed"); setProtectType(""); setBasicBldgAmt("") }}
                            >
                                Non-Landed
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {bldgType == "landed" ?
                <div className="mb-3 row">
                    <label className="col-sm-4 col-form-label">Number of storey(s)</label>
                    <div className="col-sm-8">
                        <Select
                            styles={{
                                control: provided => ({ ...provided, borderRadius: "2rem" })
                            }}
                            placeholder="Select number of storey(s)"
                            value={basicStoreyList.find(obj => obj.label === basicStorey)}
                            options={basicStoreyList}
                            onChange={(e) => { setBasicStorey(e.label); }}
                        />
                    </div>
                </div> : ""
            }
            <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">I would like to protect</label>
                <div className="col-sm-8">
                    <div className="mb-3 row align-items-center">
                        <div className="col-sm-4 d-grid">
                            <Button
                                type="button"
                                variant={protectType == "building" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                
                                disabled={!(basicType == "owner")}
                                onClick={() => { setProtectType("building"); setBasicContentAmt("") }}
                            >
                                Building
                            </Button>
                        </div>
                        <div className="col-sm-4 d-grid">
                            <Button
                                type="button"
                                variant={protectType == "content" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                
                                onClick={() => { setProtectType("content"); setBasicBldgAmt("") }}
                            >
                                Content
                            </Button>
                        </div>
                        <div className="col-sm-4 d-grid">
                            <Button
                                type="button"
                                variant={protectType == "building&content" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                
                                disabled={!(basicType == "owner")}
                                onClick={() => { setProtectType("building&content"); }}
                            >
                                Building &amp; Content
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">Gross Floor Area (in sq. ft.)</label>
                <div className="col-sm-8">
                    <Select
                        styles={{
                            control: provided => ({ ...provided, borderRadius: "2rem" })
                        }}
                        placeholder="Select Gross Floor Area"
                        value={basicGrossAreaList.find(obj => obj.label === basicGrossArea)}
                        options={basicGrossAreaList}
                        onChange={(e) => { setBasicGrossArea(e.label); }}
                    />
                </div>
            </div> */}
            <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">Year of Construction</label>
                <div className="col-sm-8">
                    <select
                        className="form-control"
                        required
                        value={selectedYear}
                        onChange={handleYearChange}
                    >
                        <option value="" disabled>Select year</option>
                        {yearOptions.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="mb-3 row">
                <label className="col-sm-4 col-form-label">Age of Building</label>
                <div className="col-sm-8">
                    <input
                        type="text"
                        className="form-control"
                        required
                        value={buildingAge}
                        onChange={(e) => setBuildingAge(e.target.value)}
                        disabled
                    />
                </div>
            </div>
            {protectType == "building" || protectType == "building&content" ?
                <div className="mb-3 row bg-light rounded pt-3">
                    <label className="col-sm-4 col-form-label">How much is your building worth?</label>
                    <div className="col-sm-8">


                         <CurrencyInput
                                id="buildingAmt"
                                autoComplete="off"
                                allowNegativeValue={false}
                                decimalSeparator="."
                                groupSeparator=","
                                className="form-control"
                                decimalsLimit={2}
                                value={basicBldgAmt}
                                decimalScale={2}
                                placeholder="RM"
                                required
                                onValueChange={(value) => {
                                    setBasicBldgAmt(value);
                                }}
                                onBlur={() => { checkSumInsuredAmount(); }}
                            />
                        <small>
                            Minimum RM 20,000 to Maximum RM 10,000,000<br />
                            To determine the Sum Insured of your properties, <a href="https://bcc.piam.org.my/" target="_blank">Click Here</a>
                        </small>
                    </div>
                </div> : ""
            }
            {protectType == "content" || protectType == "building&content" ?
                <div className="mb-3 row bg-light rounded pt-3">
                    <label className="col-sm-4 col-form-label">How much are your contents worth?</label>
                    <div className="col-sm-8">
                      
                         <CurrencyInput
                                id="contentAmt"
                                autoComplete="off"
                                allowNegativeValue={false}
                                decimalSeparator="."
                                groupSeparator=","
                                className="form-control"
                                decimalsLimit={2}
                                value={basicBldgAmt}
                                decimalScale={2}
                                required
                                placeholder="RM"
                                onValueChange={(value) => {
                                    setBasicContentAmt(value);
                                }}
                                onBlur={() => { checkSumInsuredAmount(); }}
                            />
                        <small>
                            Minimum RM 20,000 to Maximum RM 300,000<hr className="my-1" />No idea how much they are worth?
                        </small>
                        <div className="mb-3 row justify-content-end">
                            <div className="col-sm-5">
                                <Button type="button" size="sm"  onClick={() => setModalShow(true)}>Use our Home Content Calculator</Button>
                            </div>
                        </div>
                    </div>
                </div> : ""
            }
            <div className="mb-3 row text-white justify-content-between align-items-center">
                <div className="col-sm-6 bg-blue rounded py-3 mb-3 mb-sm-0">
                    <div className="row justify-content-between">
                        <label className="col-sm-5 col-form-label">Total Sum Insured</label>
                        <div className="col-sm-6">

                              <CurrencyInput
                                id="contentAmt"
                                autoComplete="off"
                                allowNegativeValue={false}
                                decimalSeparator="."
                                groupSeparator=","
                                className="form-control"
                                decimalsLimit={2}
                                required
                                value={basictotalSI}
                                decimalScale={2}
                                placeholder="RM"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-sm-4 text-end">
                    <Button type="submit" variant="success">Continue</Button>
                    <Claim
                        showClaimModal={showClaimModal}
                        basicEmailAdd={basicEmailAdd}
                        basicContactNo={basicContactNo}
                        basicProtectType={protectType}
                        setClaimInfo={props.setClaimInfo}
                        setActiveId={props.setActiveId}
                        setShowClaimModal={setShowClaimModal}
                        setEligible={setEligible}
                    />
                </div>
            </div>
            <ContentCalculator show={modalShow} onHide={() => setModalShow(false)} setModalShow={setModalShow} setbasicCntLiving={setBasicCntLiving} setbasicCntBedroom={setBasicCntBedroom}
                setbasicCntDining={setBasicCntDining} setbasicCntKitchen={setBasicCntKitchen} setbasicCntBath={setBasicCntBath} setbasicCntStore={setBasicCntStore}
                setbasicCntGarage={setBasicCntGarage} setbasicCntMItems={setBasicCntMItems} setbasicCntTotal={setBasicCntTotal} basiccntLiving={basicCntLiving} basiccntBedroom={basicCntBedroom}
                basiccntDining={basicCntDining} basiccntKitchen={basicCntKitchen} basiccntBath={basicCntBath} basiccntStore={basicCntStore}
                basiccntGarage={basicCntGarage} basiccntMItems={basicCntMItems} basiccntTotal={basicCntTotal} setbasicContentAmt={setBasicContentAmt} />
        </Form >
    );
}

function ContentCalculator(props) {
    const [activeId, setActiveId] = useState("");

    useEffect(() => {
        var totalContent = (!props.basiccntLiving ? 0 : parseFloat(props.basiccntLiving)) +
            (!props.basiccntBedroom ? 0 : parseFloat(props.basiccntBedroom)) +
            (!props.basiccntDining ? 0 : parseFloat(props.basiccntDining)) +
            (!props.basiccntKitchen ? 0 : parseFloat(props.basiccntKitchen)) +
            (!props.basiccntBath ? 0 : parseFloat(props.basiccntBath)) +
            (!props.basiccntStore ? 0 : parseFloat(props.basiccntStore)) +
            (!props.basiccntGarage ? 0 : parseFloat(props.basiccntGarage)) +
            (!props.basiccntMItems ? 0 : parseFloat(props.basiccntMItems));

        props.setbasicCntTotal(totalContent == 0 ? "" : parseFloat(totalContent).toFixed(2));
    }, [
        props.basiccntLiving, props.basiccntBedroom, props.basiccntDining, props.basiccntKitchen, props.basiccntBath,
        props.basiccntStore, props.basiccntGarage, props.basiccntMItems
    ]);

    return (
        <Modal {...props} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Content Calculator</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 mt-4">
                        <Accordion activeKey={activeId}>
                            <Card>
                                <AccordionToggle as={Card.Header} eventKey="livingroom" onClick={() => { setActiveId("livingroom"); }} className="bg-info text-white">
                                    Living Room {activeId === 'livingroom' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                                </AccordionToggle>

                                <AccordionCollapse eventKey="livingroom">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <div className="col-12 col-form-label">Covered Items</div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Sofas</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Tables and Chairs</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Carpets/ Floor Coverings / Rugs</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Curtains / Blinds</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Lightings</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Soft Furnishings</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Electrical Items</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-12 col-form-label">Key in the estimated home contents amount</label>
                                                    <div className="col-12 col-form-label">
                                                       

                                                         <CurrencyInput
                                                            id="contentAmt"
                                                            autoComplete="off"
                                                            allowNegativeValue={false}
                                                            decimalSeparator="."
                                                            groupSeparator=","
                                                            className="form-control"
                                                            decimalsLimit={2}
                                                            value={props.basiccntLiving}
                                                            decimalScale={2}
                                                            required
                                                            placeholder="RM"
                                                            onValueChange={(value) => {
                                                                props.setbasicCntLiving(value);
                                                            }}
                                                        />

                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>

                            <Card>
                                <AccordionToggle as={Card.Header} eventKey="bedroom" onClick={() => { setActiveId("bedroom"); }} className="bg-info text-white" >
                                    Bedroom {activeId === 'bedroom' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                                </AccordionToggle>

                                <AccordionCollapse eventKey="bedroom">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <div className="col-12 col-form-label">Covered Items</div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Wardrobes</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Bedroom Furniture</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Curtains / Blinds</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Carpets / Floor Coverings / Rugs</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Lightings</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Soft Furnishings</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Electrical Items</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-12 col-form-label">Key in the estimated home contents amount</label>
                                                    <div className="col-12 col-form-label">
                                                       
                                                        <CurrencyInput
                                                            id="contentAmt"
                                                            autoComplete="off"
                                                            allowNegativeValue={false}
                                                            decimalSeparator="."
                                                            groupSeparator=","
                                                            className="form-control"
                                                            decimalsLimit={2}
                                                            value={props.basiccntBedroom}
                                                            decimalScale={2}
                                                            required
                                                            placeholder="RM"
                                                            onValueChange={(value) => {
                                                                 props.setbasicCntBedroom(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>

                            <Card>
                                <AccordionToggle as={Card.Header} eventKey="diningroom" onClick={() => { setActiveId("diningroom"); }} className="bg-info text-white" >
                                    Dining Rroom {activeId === 'diningroom' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                                </AccordionToggle>

                                <AccordionCollapse eventKey="diningroom">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <div className="col-12 col-form-label">Covered Items</div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Table and Chairs</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Sofa</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Carpets / Floor Coverings / Rugs</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Curtains / Blinds</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Lightings</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Cutlery / Glassware / Silverwares</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Electrical Items</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-12 col-form-label">Key in the estimated home contents amount</label>
                                                    <div className="col-12 col-form-label">
                                                        
                                                       

                                                         <CurrencyInput
                                                            id="contentAmt"
                                                            autoComplete="off"
                                                            allowNegativeValue={false}
                                                            decimalSeparator="."
                                                            groupSeparator=","
                                                            className="form-control"
                                                            decimalsLimit={2}
                                                            value={props.basiccntDining}
                                                            decimalScale={2}
                                                            required
                                                            placeholder="RM"
                                                            onValueChange={(value) => {
                                                                props.setbasicCntDining(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>

                            <Card>
                                <AccordionToggle as={Card.Header} eventKey="kitchen" onClick={() => { setActiveId("kitchen"); }} className="bg-info text-white" >
                                    Kitchen {activeId === 'kitchen' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                                </AccordionToggle>

                                <AccordionCollapse eventKey="kitchen">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <div className="col-12 col-form-label">Covered Items</div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Cabinets / Kitchen Utensils</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Tables and Chairs</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Floor Coverings</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Lightings</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Pots and Pans</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Cutlery and Crockery</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Electrical Items</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-12 col-form-label">Key in the estimated home contents amount</label>
                                                    <div className="col-12 col-form-label">
                                                      

                                                        <CurrencyInput
                                                            id="contentAmt"
                                                            autoComplete="off"
                                                            allowNegativeValue={false}
                                                            decimalSeparator="."
                                                            groupSeparator=","
                                                            className="form-control"
                                                            decimalsLimit={2}
                                                            required
                                                            value={props.basiccntKitchen}
                                                            decimalScale={2}
                                                            placeholder="RM"
                                                            onValueChange={(value) => {
                                                                props.setbasicCntKitchen(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>

                            <Card>
                                <AccordionToggle as={Card.Header} eventKey="bathroom" onClick={() => { setActiveId("bathroom"); }} className="bg-info text-white" >
                                    Bathroom {activeId === 'bathroom' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                                </AccordionToggle>

                                <AccordionCollapse eventKey="bathroom">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <div className="col-12 col-form-label">Covered Items</div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Toilet Fittings</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Carpets / Floor Coverings / Rugs</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Toiletries</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Lighting</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Electrical Items</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-12 col-form-label">Key in the estimated home contents amount</label>
                                                    <div className="col-12 col-form-label">

                                                         <CurrencyInput
                                                            id="contentAmt"
                                                            autoComplete="off"
                                                            allowNegativeValue={false}
                                                            decimalSeparator="."
                                                            groupSeparator=","
                                                            className="form-control"
                                                            decimalsLimit={2}
                                                            required
                                                            value={props.basiccntBath}
                                                            decimalScale={2}
                                                            placeholder="RM"
                                                            onValueChange={(value) => {
                                                                props.setbasicCntBath(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>

                            <Card>
                                <AccordionToggle as={Card.Header} eventKey="store" onClick={() => { setActiveId("store"); }} className="bg-info text-white" >
                                    Store / Utility Room / Yard {activeId === 'store' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                                </AccordionToggle>

                                <AccordionCollapse eventKey="store">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <div className="col-12 col-form-label">Covered Items</div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Storage / Racking System</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Washing Machine</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Dryer Machine</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-12 col-form-label">Key in the estimated home contents amount</label>
                                                    <div className="col-12 col-form-label">
                                                        

                                                         <CurrencyInput
                                                            id="contentAmt"
                                                            autoComplete="off"
                                                            allowNegativeValue={false}
                                                            decimalSeparator="."
                                                            groupSeparator=","
                                                            className="form-control"
                                                            decimalsLimit={2}
                                                            required
                                                            value={props.basiccntStore}
                                                            decimalScale={2}
                                                            placeholder="RM"
                                                            onValueChange={(value) => {
                                                                props.setbasicCntStore(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>

                            <Card>
                                <AccordionToggle as={Card.Header} eventKey="garage" onClick={() => { setActiveId("garage"); }} className="bg-info text-white" >
                                    Car Park / Garage / Balcony / Garden {activeId === 'garage' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                                </AccordionToggle>

                                <AccordionCollapse eventKey="garage">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <div className="col-12 col-form-label">Covered Items</div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Storage / Racking System</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Tables and Chairs</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Plants Pots</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Gardening Tools</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-12 col-form-label">Key in the estimated home contents amount</label>
                                                    <div className="col-12 col-form-label">

                                                         <CurrencyInput
                                                            id="contentAmt"
                                                            autoComplete="off"
                                                            allowNegativeValue={false}
                                                            decimalSeparator="."
                                                            groupSeparator=","
                                                            className="form-control"
                                                            decimalsLimit={2}
                                                            required
                                                            value={props.basiccntGarage}
                                                            decimalScale={2}
                                                            placeholder="RM"
                                                            onValueChange={(value) => {
                                                                props.setbasicCntGarage(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>

                            <Card>
                                <AccordionToggle as={Card.Header} eventKey="mitems" onClick={() => { setActiveId("mitems"); }} className="bg-info text-white" >
                                    Miscellaneous Items {activeId === 'mitems' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                                </AccordionToggle>

                                <AccordionCollapse eventKey="mitems">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <div className="col-12 col-form-label">Covered Items</div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Watches / Handbags / Shoes</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Jewellery</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-1 text-center">
                                                                <i className="fa fa-circle fa-xxs" aria-hidden="true"></i>
                                                            </label>
                                                            <label className="col-10">Hobby Items (Bicycle, Golf Set, Fishing)</label>
                                                        </div>
                                                        <div className="row">
                                                            <label className="col-11">Note: For Watches / Handbags / Shoes / Jewelleries, an itemized list will be required. </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3 row">
                                                    <label className="col-12 col-form-label">Key in the estimated home contents amount</label>
                                                    <div className="col-12 col-form-label">
                                                        

                                                         <CurrencyInput
                                                            id="contentAmt"
                                                            autoComplete="off"
                                                            allowNegativeValue={false}
                                                            decimalSeparator="."
                                                            groupSeparator=","
                                                            className="form-control"
                                                            decimalsLimit={2}
                                                            required
                                                            value={props.basiccntMItems}
                                                            decimalScale={2}
                                                            placeholder="RM"
                                                            onValueChange={(value) => {
                                                                props.setbasicCntMItems(value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </AccordionCollapse>
                            </Card>
                        </Accordion>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row">
                    <div className="col-12">
                        <div className="mb-3 row">
                            <label className="col-sm-5 col-form-label">Total Content Sum Insured</label>
                            <div className="col-sm-7">
                               

                                 <CurrencyInput
                                    id="contentAmt"
                                    autoComplete="off"
                                    allowNegativeValue={false}
                                    decimalSeparator="."
                                    groupSeparator=","
                                    className="form-control"
                                    decimalsLimit={2}
                                    required
                                    value={props.basiccntTotal}
                                    decimalScale={2}
                                    placeholder="RM"
                                />

                                 
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="mb-3 row">
                            <label className="col-sm-5 col-form-label">Note: Figure will be rounded based on the last significate 3 digits</label>
                            <div className="col-sm-7">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <Button
                                            
                                            type="button"
                                            variant="warning"
                                            onClick={() => {
                                                props.setbasicCntLiving("");
                                                props.setbasicCntBedroom("");
                                                props.setbasicCntDining("");
                                                props.setbasicCntKitchen("");
                                                props.setbasicCntBath("");
                                                props.setbasicCntStore("");
                                                props.setbasicCntGarage("");
                                                props.setbasicCntMItems("");
                                                props.setbasicCntTotal("")
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                    <div className="col-sm-6">
                                        <Button
                                            type="button"
                                            variant="success"
                                            onClick={() => {
                                                (!props.basiccntTotal || props.basiccntTotal == "0") ?
                                                    swalAlert.fire({
                                                        title: 'Hmm...',
                                                        icon: 'warning',
                                                        showCancelButton: true,
                                                        message: 'Kindly input content amount(s).'
                                                    })
                                                    :
                                                    props.setModalShow(false);
                                                props.setbasicContentAmt(props.basiccntTotal);
                                            }}
                                        >
                                            Confirm Amount
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

function Quote(props) {
    const [selectedPlan, setSelectedPlan] = useState([]);
    const [planPremium, setPlanPremium] = useState([]);
    const [activeEventKey, setActiveEventKey] = useState("")
    const swalAlert = withReactContent(Swal);

    useEffect(() => {
        if (props.basicInfo.protectType && props.basicInfo.bldgType) {
            let basicProtectType = props.basicInfo.protectType;
            let basicBldgType = props.basicInfo.bldgType;
            let basicBldgAmt = !props.basicInfo.basicBldgAmt ? "0" : props.basicInfo.basicBldgAmt;
            let basicContentAmt = !props.basicInfo.basicContentAmt ? "0" : props.basicInfo.basicContentAmt;

            let protectType = "";
            if (basicProtectType == "content" && basicBldgType == "landed")
                protectType = "C";
            else if (basicProtectType == "content" && basicBldgType == "non-landed")
                protectType = "CX";
            else if (basicProtectType == "building&content" && basicBldgType == "landed")
                protectType = "CL";
            else if (basicProtectType == "building&content" && basicBldgType == "non-landed")
                protectType = "CNL";
            else if (basicProtectType == "building" && basicBldgType == "landed")
                protectType = "L";
            else if (basicProtectType == "building" && basicBldgType == "non-landed")
                protectType = "NL";

            axios.get('/api/comparisons/' + protectType + '/' + basicBldgAmt + '/' + basicContentAmt)
                .then(response => {
                    setPlanPremium(response.data);

                    swalAlert.close();
                });
        }
    }, [props.basicInfo]);

    useEffect(() => {
        if (props.activeId === 'quote') {
            swalAlert.fire({
                title: 'Please Wait...',
                allowOutsideClick: false
            });

            swalAlert.showLoading();

            if (planPremium.length > 0) {
                swalAlert.close();
            }
        }
    }, [props.activeId, planPremium])

    function onClickNext(e) {
        e.preventDefault();
        e.stopPropagation();
        //props.setComparisonInfo(selectedPlan);
        //props.setActiveId("addtl");
    }

    function Overview(props) {
        if (props.insurer == 'MPIG') {
            return (
                <>
                    <h5 className="text-primary">Policy Summary</h5>
                    <p>
                        An all-encompassing home insurance protection plan that offers a more comprehensive
                        coverage that anticipates Building (Houseowner) or Contents (Householder) coverages
                        needs. Enhanced features includes:
                    </p>
                    <h6 className="text-primary">BUILDING and/or CONTENTS</h6>
                    <ul>
                        <li>
                            Worldwide Personal Accident - RM 10,000 per person up to maximum 5 family members
                            residing with you
                        </li>
                        <li>Emergency Cash Allowance or Inconvenience Allowance - payable up to RM 1,500</li>
                    </ul>
                    <h6 className="text-primary">BUILDING ONLY</h6>
                    <ul>
                        <li>
                            Cost of Replacing Burst Water Pipe including Hacking and Plastering - payable up
                            to RM 1,500
                        </li>
                        <li>Terrorism Cover - payable up to RM 500,000</li>
                    </ul>
                    <h6 className="text-primary">CONTENTS ONLY</h6>
                    <ul>
                        <li>
                            Fraudulent Use of Credit / ATM Card - payable up to RM 1,000
                        </li>
                    </ul>
                    <p className="text-primary">Special Feature</p>
                    <ul className="checkmark">
                        <li>Does not apply any “per article limit” to your contents.</li>
                        <li>No penalty for under insurance.</li>
                        <li>
                            The full cost of repairing the damage to property is paid without any deductions
                            being made for wear-and-tear or depreciation.
                        </li>
                    </ul>
                </>
            );
        } else if (props.insurer == 'AXA') {
            return (
                <>
                    <h5 className="text-primary">Policy Summary</h5>
                    <p>
                        An comprehensive coverage that allows you to choose the type of protection to suit for your need for your
                        Building (Houseowner) and Contents (Householder). Enhanced features includes:
                    </p>
                    <h6 className="text-primary">BUILDING (HOUSEOWNER)</h6>
                    <ul>
                        <li>Loss of rent / Costs of temporary accommodation - 10% of Building Sum Insured</li>
                        <li>Owner's / Tenant's Liability - RM 50,000</li>
                        <li>Removal of Debris - 10% of Building Sum Insured (max RM 2,000,000)</li>
                        <li>Architect, Surveyor &amp; Consultant's Fees - included as part of Building Sum Insured</li>
                    </ul>
                    <h6 className="text-primary">CONTENTS (HOUSEHOLDER)</h6>
                    <ul>
                        <li>Loss of money due to theft - up to RM 1,000</li>
                        <li>Cost of replacing locks / keys due to housebreaking - up to RM 500</li>
                        <li>Deterioration of food in the freezer - up to RM 250</li>
                        <li>Cost of replacing legal documents - up to RM 1,000</li>
                        <li>Loss or damage to contents during temporary removal - 15% of total value of contents</li>
                        <li>Loss or damage to water filter outside building - Up to RM 1,000</li>
                        <li>Cost of repairing burst water pipe including hacking - up to RM 1,000</li>
                        <li>Emergency Cash Allowance - up to RM 1,000</li>
                        <li>Fraudulent Use of Credit / ATM card - Up to RM 500</li>
                        <li>Fraud or Dishonesty of Domestic Servant - up to RM 500</li>
                        <li>Fire Extinguishment Expenses - up to RM 1,000</li>
                    </ul>
                    <p className="text-primary">Special Feature</p>
                    <ul className="checkmark">
                        <li>
                            "New for Old" cover for Home Contents - 'New' item in replacement of the loss or damaged "Old" item
                            in the event of a claim (excluding jewellery).
                        </li>
                    </ul>
                </>
            );
        } else if (props.insurer == 'TUNE') {
            return (
                <>
                    <h5 className="text-primary">Key Benefits</h5>
                    <div className='mt-2 ms-2'>
                        <h6 className="text-primary">HOUSEOWNER (BUILDING)</h6>
                        <ul>
                            <li>Covers residentials building including garages, fixtures and fittings, walls, gates and fences around the premise</li>
                        </ul>
                        <h6 className="text-primary">HOUSEHOLDER (CONTENTS)</h6>
                        <ul>
                            <li>Covers your household contents and personal effects.</li>
                        </ul>
                        <h6 className="text-primary">LANDLORD INSURANCE PACK</h6>
                        <ul>
                            <li>Protection against loss of rental income, unoccupied premise and damage to content by your tenant.</li>
                        </ul>
                        <h6 className="text-primary">PERSONAL LIABILITY</h6>
                        <ul>
                            <li>Covers your legal liability to third parties including legal cost and expenses in respect of bodily injury and property damage.</li>
                        </ul>
                        <h6 className="text-primary">MORTGAGE LOAN PROTECTION PACK</h6>
                        <ul>
                            <li>Covers your monthly loan installment in the event that your house is deemed temporarily uninhabitable due to insured events or the insured suffers accidental death or total permanent disablement.</li>
                        </ul>
                        <h6 className="text-primary">HOME CARE PACK</h6>
                        <ul>
                            <li>Covers reimbursement for repair of burst pipes, loss or damage to fixtures and fittings caused by termite and more.</li>
                        </ul>
                        <h6 className="text-primary">SMART HOME DEVICE PROTECTION PACK</h6>
                        <ul>
                            <li>Covers smart home devices due to destruction or damage caused by any accident or misfortune.</li>
                        </ul>
                    </div>

                </>
            );
        } else if (props.insurer == 'LIBERTY') {
            return (
                <>
                    <h5 className="text-primary">Key Benefits</h5>
                    <div className='mt-2 ms-2'>
                        <h6 className="text-primary">HOUSEOWNER (BUILDING)</h6>
                        <ul>
                            <li>Covers residentials building including garages, fixtures and fittings, walls, gates and fences around the premise</li>
                        </ul>
                        <h6 className="text-primary">HOUSEHOLDER (CONTENTS)</h6>
                        <ul>
                            <li>Covers your household contents and personal effects.</li>
                        </ul>
                        <h6 className="text-primary">LANDLORD INSURANCE PACK</h6>
                        <ul>
                            <li>Protection against loss of rental income, unoccupied premise and damage to content by your tenant.</li>
                        </ul>
                        <h6 className="text-primary">PERSONAL LIABILITY</h6>
                        <ul>
                            <li>Covers your legal liability to third parties including legal cost and expenses in respect of bodily injury and property damage.</li>
                        </ul>
                        <h6 className="text-primary">MORTGAGE LOAN PROTECTION PACK</h6>
                        <ul>
                            <li>Covers your monthly loan installment in the event that your house is deemed temporarily uninhabitable due to insured events or the insured suffers accidental death or total permanent disablement.</li>
                        </ul>
                        <h6 className="text-primary">HOME CARE PACK</h6>
                        <ul>
                            <li>Covers reimbursement for repair of burst pipes, loss or damage to fixtures and fittings caused by termite and more.</li>
                        </ul>
                        <h6 className="text-primary">SMART HOME DEVICE PROTECTION PACK</h6>
                        <ul>
                            <li>Covers smart home devices due to destruction or damage caused by any accident or misfortune.</li>
                        </ul>
                    </div>

                </>
            );
        } else {
            return null;
        }
    }

    function PolicyDetails(props) {
        if (props.insurer == 'MPIG') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' building-content'} className="text-primary">
                                BUILDING and/or CONTENTS
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' building-content'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">Fire, Lightning, Thunderbolt, Subterranean Fire</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Explosion caused by Gas used for Domestic Purposes</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Aircraft &amp; other Aerial Devices and/or articles dropped therefrom</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Impact with any buildings by road vehicles or animals</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Bursting or overflowing of Domestic Water Tank, Apparatus or Pipes
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess: First RM 50
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Theft, but only if accompanied by actual forcible and violent breaking into or out of a building or any such attempt</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Hurricane, Cyclone, Typhoon, Windstorm
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-2"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess: First 1% of the Total Sum Insured on Building or RM 200 whichever shall be the less.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Earthquake, Volcanic Eruption
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-3"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess: First 1% of the Total Sum Insured on Building or RM 200 whichever shall be the less.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Flood
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-4"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess: First 1% of the Total Sum Insured on Building or RM 200 whichever shall be the less.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Robbery and hold up in the premises of your property</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Liability to The Public</td>
                                                        <td className="align-middle text-center">Not exceeding RM 50,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Fire Brigade Report</td>
                                                        <td className="align-middle text-center">Reimburse up to RM 100</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Fire Brigade Charges *</td>
                                                        <td className="align-middle text-center">Reimburse up to RM 500. Cost to replenish Fire Fighting Appliances</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Worldwide Personal Accident *</td>
                                                        <td className="align-middle text-center">RM 10,000 per person (Up to 5 family members)</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Emergency Cash Allowance or Inconvenience Allowance</td>
                                                        <td className="align-middle text-center">Up to RM 1,500</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Domestic Help / Maid Allowance</td>
                                                        <td className="align-middle text-center">Up to RM 250</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' contents'} className="text-primary">
                                CONTENTS ONLY
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' contents'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">Compensation for Death (caused by fire or theft)</td>
                                                        <td className="align-middle text-center">If more than 1 maned insured person, pro-rated compensation. Limit up to RM 10,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Jewellery &amp; Luxury items, Total value of platinum, gold and silver articles, jewellery and furs</td>
                                                        <td className="align-middle text-center">Shall not exceed 1/3 of the Total Sum Insured</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Contents Temporarily Removed, but remaining within Mlaaysia</td>
                                                        <td className="align-middle text-center">Limit to 15% of Total Sum Insured</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Breakage of Mirrors</td>
                                                        <td className="align-middle text-center">RM 500 per piece on any one accident</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Cost of Replacing Legal Documents due to Fire, Flood or Theft (i.e. Passport, MRID, Driving License, Legal Will) *</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Loss of Personal Money at Home *</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Fradulent Use of Credit / ATM Card (due to Theft) *</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Servants' Property (Loss / Damage to Personal Effects) *</td>
                                                        <td className="align-middle text-center">Payable, part of content</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' building'} className="text-primary">
                                BUILDING ONLY
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' building'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">Maintenance Fee Protection Benefits *</td>
                                                        <td className="align-middle text-center">Up to RM 250</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Terrorism Cover (Material Damage only) *</td>
                                                        <td className="align-middle text-center">Payable up to RM 500,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Replacement of Window . Door / External Locks *</td>
                                                        <td className="align-middle text-center">Limit - RM 500 per piece any one incident</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Replacement of Burst Pipe including hacking and plastering *</td>
                                                        <td className="align-middle text-center">Up to RM 1,500</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' add-ons-building'} className="text-primary">
                                OPTIONAL / EXTENDED COVER - BUILDING ONLY
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' add-ons-building'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional: Landlord's Household Goods and Furnishings (Flats / Apartments)
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            What is not Covered?
                                                                            <ul>
                                                                                <li>Household goods, furnishing or personal effects of any descriptions brought into by tenants</li>
                                                                                <li>Gold and Silver articles</li>
                                                                            </ul>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional: Plate Glass
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            What is not Covered?
                                                                            <ul>
                                                                                <li>Breakage to frames or frameworks</li>
                                                                                <li>Cost of removal or replacement of at fittings or fixtures</li>
                                                                                <li>Breakage of glass in conservations, green house or outbuildings</li>
                                                                                <li>Any consequential loss</li>
                                                                            </ul>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Loss or Damage by Hurricane, Cyclone, Typhoon or Windstorm to metal smoke stacks, awnings, blinds, signs and other outdoor fixtures and fittings including gates and fences</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Optional: Alterations, repairs and additions (but not appreciation in value in excess of the sum insured)</td>
                                                        <td className="align-middle text-center">Not exceeding 25% of the Total Sum Insured on Buildings</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' add-ons-contents'} className="text-primary">
                                OPTIONAL / EXTENDED COVER - CONTENTS ONLY
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' add-ons-contents'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional: Extension for extended theft cover but excluding theft by domestic servants or any members of Your family or Household
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess RM 250 or 1% of Total Sum Insured whichever is lower.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional: Extensions for ectended theft but includeing theft by domestic servants
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess RM 250 or 1% of Total Sum Insured whichever is lower.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion>
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' add-ons-building-contents'} className="text-primary">
                                OPTIONAL / EXTENDED COVER - BUILDING and/or CONTENTS
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' add-ons-building-contents'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">Optional: Increase of Indemnity Limits under Additional benefits - Rent Insurance</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Optional: Increase of Indemnity Limits under Additional Benefits - Liability to The Public</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional: Extension to Cover Subincidence and Landslip
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            What is not covered?
                                                                            Loss or damage:
                                                                            <ol type="a">
                                                                                <li>To swimming pools, terraces, patios, drives, footpath, walls, gates or fences unless the buildings, its outbuilding or garages are damaged at the same time.</li>
                                                                                <li>To or resulting from movement of sold flood slabs, unless with foundation beneath the external wall of building are damaged at the same time</li>
                                                                                <li>Directly or indirectly caused by coastal or river erosion;  demolition, structural alteration or structural repair; defective design or inadequate construction of foundation</li>
                                                                            </ol>
                                                                            Compulsory Excess: 5% of the total sum insured or RM 25,000 whichever is lower.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional Extension to Cover Riot, Strike and Malicious Damage
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            What is not covered?
                                                                            Loss or damage:
                                                                            <ol type="a">
                                                                                <li>War, invasion, act of foreign enemy, hostilities, or warlike operations (whether war be declared or not), civil war, mutiny, civil commotion assuming proportions of or amounting to popular uprising, military uprising, insurrection, rebellion, revolution, military or usurped power, </li>
                                                                                <li>In respect of malicious act, insurer shall not be liable for any loss or damage arising out of or in the course of burglary, housebreaking, theft or larceny or any attempt of such acts.</li>
                                                                                <li>Loss of earning, loss of market or any consequential loss or damage</li>
                                                                                <li>Caused by permanent or temporary dispassion commandeering or requisition by any lawfully constitute authority</li>
                                                                                <li>Caused by permanent or temporary dispossession of any building resulting from the unlawful occupation by any person of such building.</li>
                                                                            </ol>
                                                                            Compulsory Excess: 5% of the total sum insured or RM 25,000 whichever is lower.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Rent Insurance</td>
                                                        <td className="align-middle text-center">Not exceeeding 10% of Total Sum Insured</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                </>
            );
        } else if (props.insurer == 'AXA') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' building-content'} className="text-primary">
                                SECTION A - BUILDING (HOUSEOWNER)
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' building-content'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">Fire, Lightning, Thunderbolt, Subterranean Fire</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Explosion caused by Gas used for Domestic Purposes</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Aircraft &amp; other Aerial Devices and/or articles dropped therefrom</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Impact with any buildings by road vehicles or animals</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Bursting or overflowing of Domestic Water Tank, Apparatus or Pipes
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess: First RM 50
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Theft, but only if accompanied by actual forcible and violent breaking into or out of a building or any such attempt</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Hurricane, Cyclone, Typhoon, Windstorm
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-2"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess: First 1% of the Total Sum Insured on Building or RM 200 whichever shall be the less.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Earthquake, Volcanic Eruption
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-3"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess: First 1% of the Total Sum Insured on Building or RM 200 whichever shall be the less.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Flood
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-4"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            Compulsory Excess: First 1% of the Total Sum Insured on Building or RM 200 whichever shall be the less.
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Robbery and hold up in the premises of your property</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Loss of rent / Cost of temporary accomodation</td>
                                                        <td className="align-middle text-center">10% of Building Sum Insured</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Owner's / Tenant Liability</td>
                                                        <td className="align-middle text-center">Reimburse up to RM 50,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Removal of Debris</td>
                                                        <td className="align-middle text-center">10% of Building Sum Insured (max RM 2,000,000)</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Architect, Surveyor &amp; Consultant's Fees</td>
                                                        <td className="align-middle text-center">included as part of Building Sum Insured</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' add-ons-building'} className="text-primary">
                                OPTIONAL / EXTENDED COVER - BUILDING ONLY
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' add-ons-building'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional: Extension to Cover Riot, Strike and Malicious Damage
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            What is not Covered?
                                                                            <p>Loss or damage:</p>
                                                                            <ol type="a">
                                                                                <li>
                                                                                    War, invasion, act of foreign enemy, hostilities, or warlike operations (whether war be declared or not), civil war,
                                                                                    mutiny, civil commotion assuming proportions of or amounting to popular uprising, military uprising, insurrection,
                                                                                    rebellion, revolution, military or usurped power.
                                                                                </li>
                                                                                <li>
                                                                                    In respect of malicious act, insurer shall not be liable for any loss or damage arising out of or in the course of
                                                                                    burglary, housebreaking, theft or larceny or any attempt of such acts.
                                                                                </li>
                                                                                <li>Loss of earning, loss of market or any consequential loss or damage</li>
                                                                                <li>Caused by permanent or temporary dispassion commandeering or requisition by any lawfully constitute authority.</li>
                                                                                <li>
                                                                                    Caused by permanent or temporary dispossession of any building resulting from the unlawful occupation by any person
                                                                                    of such building.
                                                                                </li>
                                                                            </ol>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional: Extension to Cover Subsidence and Landslip
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            What is not Covered?
                                                                            <ol type="a">
                                                                                <li>
                                                                                    To swimming pools, terraces, patios, drives, footpath, walls, gates or fences unless the buildings, its outbuilding
                                                                                    or garages are damaged at the same time.
                                                                                </li>
                                                                                <li>
                                                                                    To or resulting from movement of sold flood slabs, unless with foundation beneath the external wall of building are
                                                                                    damaged at the same time.
                                                                                </li>
                                                                                <li>
                                                                                    Directly or indirectly caused by coastal or river erosion; demolition, structural alteration or structural repair;
                                                                                    defective design or inadequate construction of foundation.
                                                                                </li>
                                                                            </ol>

                                                                            <p className="my-3">Compulsory Excess: 5% of the total sum insured or RM 25,000 whichever is lower.</p>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Optional: Extension to Cover Impact Damage (including Insured's Own Vehicle)</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Optional: Extension to Cover Plate Glass Damage</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Optional: Extension to Cover Damage of Falling Trees or Branches</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Optional: Alterations, repairs and additions (but not appreciation in value in excess of the sum insured) </td>
                                                        <td className="align-middle text-center">Not exceeding 25% of the Total Sum Insured on Buildings</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Optional: Extension to Cover Subsidence and Lanslip (deletion of exclusion A)
                                                            <OverlayTrigger
                                                                trigger={['hover', 'click']}
                                                                key={"popup-1"}
                                                                placement="right"
                                                                overlay={
                                                                    <Popover>
                                                                        <Popover.Body>
                                                                            The policy extend to cover loss or damage caused by subsidence and/or heave of the site on which the buildings stand or land
                                                                            belonging thereto, or landslip excluding:
                                                                            <ul>
                                                                                <li>
                                                                                    Loss or damage to or resulting from movement of solid floor slabs , unless with foundation beneath the external wall
                                                                                    of building are damaged at the same time.
                                                                                </li>
                                                                                <li>
                                                                                    Directly or indirectly caused by coastal or river erosion; demolition, structural alteration or structural repair;
                                                                                    defective design or inadequate construction of foundation
                                                                                </li>
                                                                            </ul>

                                                                            <p className="my-3">
                                                                                Compulsory Excess: 5% of the total sum insured or RM 25,000 whichever is lower.
                                                                            </p>
                                                                        </Popover.Body>
                                                                    </Popover>
                                                                }
                                                            >
                                                                <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' building'} className="text-primary">
                                SECTION B - CONTENTS (HOUSEHOLDER)
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' building'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">Loss or damage to Contents including Personal Effects belonging to you or family members permanently residing with you whilst contained in Your building specified in the Schedule used solely for residential purposes</td>
                                                        <td className="align-middle text-center"><i className="fas fa-check text-primary"></i></td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Loss of money due to theft</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Cost of replacing keys/locks due to housebreaking</td>
                                                        <td className="align-middle text-center">Up to RM 500</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Deteriorating of food in freezer</td>
                                                        <td className="align-middle text-center">Up to RM 250</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Cost of replacing legal documents</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Loss or damage to contents during temporary removal</td>
                                                        <td className="align-middle text-center">15% of total value of Contents</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Loss or damage to water filter outside building</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Cost of repairing burst water pipe including hacking</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Emergency Cash Allowance</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Fraudulent Use of Credit / ATM Card</td>
                                                        <td className="align-middle text-center">Up to RM 500</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Fraud or Dishonesty of Domestic Servant</td>
                                                        <td className="align-middle text-center">Up to RM 500</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="align-middle">Fire Extinguishment Expenses</td>
                                                        <td className="align-middle text-center">Up to RM 1,000</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' add-ons-building'} className="text-primary">
                                SECTION C - WORLDWIDE PERSONAL ALL RISKS
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' add-ons-building'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">Cover loss or damage to personal effects e.g. jewellery, watches, cameras, etc</td>
                                                        <td className="align-middle text-center">
                                                            Maximum per item: RM 10,000
                                                            Excess: RM 150 each and every loss
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' add-ons-contents'} className="text-primary">
                                SECTION D - WORLDWIDE FAMILY LIABILITY
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' add-ons-contents'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table responsive>
                                                <tbody>
                                                    <tr>
                                                        <td className="align-middle">
                                                            Indemnify against third party accidental bodily injury or accidental damage to property
                                                        </td>
                                                        <td className="align-middle text-center">RM 200,000</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>

                    <p className="text-primary font-italic mt-4 mb-3">Section C and D are subject to additional premium</p>
                </>
            );
        } else if (props.insurer == 'TUNE') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' houseowner-insurance'} className="text-primary">
                                Section 1 - Building: HouseOwner Insurance (Policy must consist either Houseowner/Householder)
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' houseowner-insurance'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <ul>
                                                <li>Loss or damage to your building due to fire, lightning and explosion caused by gas used for domestic purposes</li>
                                                <li>Loss or damage to your building by aircraft and other aerial devices and/or articles dropped therefrom, impact of road vehicles or animals, bursting or overflowing of water tanks or pipes, theft by forcible and violent entry, hurricane, cyclone, typhoon, windstorm, earthquake, volcanic eruption and flood</li>
                                                <li>Loss of rent (up to 10% of the total sum insured)</li>
                                                <li>Liability to third parties for accidents in your house (Limit of Liability up to RM50,000)</li>
                                                <li>Robbery and hold up in the premises of the insured property</li>
                                                <li>Reimbursement of increased in Water Bill arising from an unexpected burst pipe(s)</li>
                                                <li>Safety Net - Pay up to a maximum of 110% of the Sum Insured on Section 1 - Building if your home is completely destroyed by insured perils.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' contents'} className="text-primary">
                                Section 2 - Contents: HouseHolder Insurance (Policy must consist either Houseowner/Householder)
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' contents'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <ul>
                                                <li>Loss or damage to your contents due to fire, lightning and explosion caused by gas used for domestic purposes</li>
                                                <li>Loss or damage to your contents by aircraft and other aerial devices and/or articles dropped therefrom, impact of road vehicles or animals, bursting or overflowing of water tanks or pipes, theft by forcible and violent entry, hurricane, cyclone, typhoon, windstorm, earthquake, volcanic eruption and flood</li>
                                                <li>Loss of rent (up to 10% of the total sum insured)</li>
                                                <li>Liability to third parties for accidents in your house (Limit of Liability up to RM50,000)</li>
                                                <li>Property temporarily removed for sale exhibition or to furniture depositories.</li>
                                                <li>Damage to mirrors</li>
                                                <li>Compensation for fatal injury occurring by visible violence caused by thieves or by fire.</li>
                                                <li>Servants’ property</li>
                                                <li>Robbery and hold up in the premises of the insured property</li>
                                                <li>Reimbursement of increased in Water Bill arising from an unexpected burst pipe(s)</li>
                                            </ul>
                                            <p>**** For Section 1 (Houseowner) and Section 2 (Householder), you may extend coverage to the following risks by paying additional premium:</p>
                                            <ul>
                                                <li>Subsidence and landslip, riot, strike and malicious damage, bush/lalang fire, damage by falling trees or branches and objects</li>
                                                <li>Loss or damage by hurricane, cyclone, typhoon or windstorm to metal smoke stacks, awnings, blinds, signs and other outdoor fixtures and fittings including gates and fences</li>
                                                <li>Alterations, repairs and additions;</li>
                                                <li>Extended Theft cover;</li>
                                                <li>Increased limit of liability to third parties for accidents in your house.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' add-on'} className="text-primary">
                                ADD-ON COVERAGE (Optional Benefit and subject to additional premium) <br />Section 3 - Add-On Coverage
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' add-on'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <h5>3.1 - Landlord Insurance Pack</h5>
                                            <p>Covers malicious damage by tenant and loss of income due tenant runaway. Tune will also bear the legal fee of issuing a letter of demand for rent past due.</p>
                                            <p>Also provides 90 days additional coverage for</p>
                                            <p>
                                                <span className='m-2'>(a)</span>
                                                <span>Loss or damage of theft or burglary happening whilst Your Premises have been left unoccupied for a continuous period exceeding ninety (90) consecutive days and nights in excess of ninety (90) days of Section 2 - Householder (Content).</span>
                                            </p>
                                            <p className='mx-5'>OR</p>
                                            <p>
                                                <span className='m-2'>(b)</span>
                                                <span>Loss or damage of theft or burglary happening whilst Your Premises have been left unoccupied for a continuous period exceeding ninety (90) consecutive days and nights</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h5>3.2 - Mortgage Loan Protection Pack</h5>
                                            <p>Provides you insurance coverage in the event your house is deemed temporarily uninhabitable due to insured events or the insured suffers accidental death or total permanent disablement.</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h5>3.3 - Home Care Pack</h5>
                                            <p>Provides insurance coverage by reimbursing you the:</p>
                                            <p>
                                                <span className='m-2'>i.</span>
                                                <span>cost incurred in repairing or replacing the damaged or broken pipe(s) as a result of an unexpected burst pipe(s).</span>
                                            </p>
                                            <p>
                                                <span className='m-2'>ii.</span>
                                                <span>cost incurred in repairing or replacing the damaged fixtures or fittings caused by termites.</span>
                                            </p>
                                            <p>
                                                <span className='m-2'>iii.</span>
                                                <span>cost incurred for repairing, changing or replacing the external doors, locks and windows or temporary repair caused by violence and forcible break-in or attempted break-in to your building.</span>
                                            </p>
                                            <p>
                                                <span className='m-2'>iv.</span>
                                                <span>expenses for engaging domestic help/cleaning services due to insured events.</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h5>3.4 - SmartHome Devices Protection Pack</h5>
                                            <p>Provides you insurance coverage for smart home devices due to destruction or damage caused by any accident or misfortune.</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' benefits'} className="text-primary">
                                Section 4 - Exclusive Benefits (Complimentary)
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' benefits'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <h5>4.1 - Personal Liability</h5>
                                            <p>Covers your legal liability to third parties including legal cost and expenses in respect of bodily injury and property damage.</p>
                                            <h6>Note:</h6>
                                            <p>*This benefit is complimentary with the combined purchase of Section 1: HouseOwner and Section 2: Householders (Content)</p>
                                            <p>** You may purchase standalone Personal Liability by paying additional premium if you did not combine the purchase of Section 1: HouseOwner and Section 2: Householders (Content)</p>
                                            <p className='font-italic'>Duration of cover is for one (1) year. You will need to renew the insurance plan annually.</p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                </>
            );
        } else if (props.insurer == 'LIBERTY') {
            return (
                <>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' houseowner-insurance'} className="text-primary">
                            Section 1 � Building: HouseOwner Insurance (Policy must consist either Houseowner/Householder)
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' houseowner-insurance'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <ul>
                                                <li>Loss or damage to your building due to fire, lightning and explosion caused by gas used for domestic purposes</li>
                                                <li>Loss or damage to your building by aircraft and other aerial devices and/or articles dropped therefrom, impact of road vehicles or animals, bursting or overflowing of water tanks or pipes, theft by forcible and violent entry, hurricane, cyclone, typhoon, windstorm, earthquake, volcanic eruption and flood</li>
                                                <li>Loss of rent (up to 10% of the total sum insured)</li>
                                                <li>Liability to third parties for accidents in your house (Subject to Liberty General Insurance Berhad's policy)</li>
                                                <li>Robbery and hold up in the premises of the insured property</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                    <Accordion className="mb-3">
                        <Card>
                            <AccordionToggle as={Card.Header} eventKey={props.insurer + ' contents'} className="text-primary">
                                Section 2 � Contents: HouseHolder Insurance (Policy must consist either Houseowner/Householder)
                            </AccordionToggle>
                            <AccordionCollapse eventKey={props.insurer + ' contents'}>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12">
                                            <ul>
                                                <li>Loss or damage to your contents due to fire, lightning and explosion caused by gas used for domestic purposes</li>
                                                <li>Loss or damage to your contents by aircraft and other aerial devices and/or articles dropped therefrom, impact of road vehicles or animals, bursting or overflowing of water tanks or pipes, theft by forcible and violent entry, hurricane, cyclone, typhoon, windstorm, earthquake, volcanic eruption and flood</li>
                                                <li>Loss of rent (up to 10% of the total sum insured)</li>
                                                <li>Liability to third parties for accidents in your house (Subject to Liberty General Insurance Berhad's policy)</li>
                                                <li>Property temporarily removed but remaining wihtin the Geographical Area. (Limit to 15% of Total Sum Insured)</li>
                                                <li>Damage to mirrors (Limit of Liability - RM500.00 per piece any one accident)</li>
                                                <li>Compensation for fatal injury occurring by visible violence caused by thieves or by fire.</li>
                                                <li>Servants� property</li>
                                                <li>Robbery and hold up in the premises of the insured property</li>
                                            </ul>
                                            <p>**** For Section 1 (Houseowner) and Section 2 (Householder), you may extend coverage to the following risks by paying additional premium:</p>
                                            <ul>
                                                <li>Subsidence and landslip, riot, strike and malicious damage, bush/lalang fire, damage by falling trees or branches and objects</li>
                                                <li>Loss or damage by hurricane, cyclone, typhoon or windstorm to metal smoke stacks, awnings, blinds, signs and other outdoor fixtures and fittings including gates and fences</li>
                                                <li>Alterations, repairs and additions;</li>
                                                <li>Extended Theft cover;</li>
                                                <li>Increased limit of liability to third parties for accidents in your house.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                </>
            );
        } else {
            return null;
        }
    }

    function Faq(props) {
        if (props.insurer == 'TUNE') {
            return (
                <>
                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-primary">How much premium do I have to pay?</h5>
                            <p>
                                The total premium amount you will have to pay depends on the sum insured and/or according to the plan you select.
                                Minimum of RM60.00 is applicable to the Section 1 (Houseowner) and Section 2 (Householder) total premium.
                                Premium Payment can be made via Cash, Credit Card, Internet Banking and Cheque.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-primary">What are some of the key terms and conditions that I should be aware of?</h5>
                            <h6><span className='m-1'>a)</span>Importance of Disclosure</h6>
                            <p className='ms-4'>
                                Pursuant to Paragraph 5 of Schedule 9 of the Financial Services Act 2013, if you are applying for this Insurance
                                wholly for purposes unrelated to your trade, business or profession, you have a duty to take reasonable care not
                                to make a misrepresentation in answering the questions in the Proposal Form (or when you apply for this insurance).
                            </p>
                            <p className='ms-4'>
                                You must answer the questions fully and accurately.
                            </p>
                            <p className='ms-4'>
                                Failure to take reasonable care in answering the questions may result in avoidance of your contract of insurance,
                                refusal or reduction of your claim(s), change of terms or termination of your contract of insurance.
                            </p>
                            <p className='ms-4'>
                                The above duty of disclosure shall continue until the time your contract of insurance is entered into, varied or renewed with us.
                            </p>
                            <p className='ms-4'>
                                In addition to answering the questions in the Proposal Form (or when you apply for this insurance), you are required to disclose any other matter that you know to be relevant to our decision in accepting the risks and determining the rates and terms to be applied.
                            </p>
                            <p className='ms-4'>
                                You also have a duty to tell us immediately if at any time after your contract of insurance has been entered into, varied or renewed with us any of the information given in the Proposal Form (or when you applied for this insurance) is inaccurate or has changed.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>b)</span>Duty of Assured</h6>
                            <p className='ms-4'>
                                You should take all reasonable precautions to prevent claim incidents.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>c)</span>Premium Warranty</h6>
                            <p className='ms-4'>
                                You must pay the premium and the premium must be received by the insurer within sixty (60) days from the policy/ endorsement/renewal certificate inception date.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>d)</span>Submission of Claim</h6>
                            <p className='ms-4'>
                                In the event of a claim, you are required to notify us within thirty (30) days from the date of the accident and submit the relevant documents within fourteen (14) days thereof
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>e)</span>Insured Value/Sum Insured</h6>
                            <p className='ms-4'>
                                You must ensure that your property is insured at the appropriate amount taking into account the renovations made to your property. If the amount insured in your policy is less than the actual value at the time of loss (i.e. under-insurance), you are deemed to be self-insuring the difference. This average condition will apply in the event of a claim.
                            </p>
                            <p className='ms-4'>
                                You may use the PIAM Building Cost Calculator (BCC) to guide you in determining the Sum Insured for your residential properties. You may access the BCC via our website at www.tuneprotect.com or PIAM's website at www.piam.org.my.
                            </p>
                            <p className='ms-4'>
                                Excesses, being the amount you have to bear before we indemnify you, are applicable for certain perils, such as overflowing of domestic water tanks, windstorm, earthquake and flood claims.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>f)</span>Policy Expiry</h6>
                            <p className='ms-4'>
                                Unless renewed, coverage will cease upon policy expiry date.
                                (Note: Please refer to the policy wording for the full terms and conditions of this policy.)
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-primary">What are the major exclusions under this policy?</h5>
                            <p>This policy does not cover certain losses such as:</p>
                            <ul>
                                <li>Loss / damage due to subsidence, landslip, riot, strike and malicious damage: unless with additional premium</li>
                                <li>War, Civil War and any Act of Terrorism</li>
                                <li>Radioactive and Nuclear Energy Risks</li>
                                <li>Date recognition</li>
                                <li>Property Damage to data or software</li>
                                <li>Loss of damage by burst pipes whilst the building is untenanted</li>
                            </ul>
                            <p>(Note: This list is non-exhaustive. Please refer to the policy contract for the full list of exclusions under this policy.)</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-primary">Can I cancel my policy?</h5>
                            <p>You may cancel your policy at any time by giving written notice to us in which case we shall retain the customary short period rate for the time the policy has been in force. Upon cancellation, you are entitled to a refund premium subject to the minimum premium to be retained by the company. No refund of premium will be allowed if there is a claim under the policy.</p>
                        </div>
                    </div>
                </>
            );
        } else if (props.insurer == 'LIBERTY') {
            return (
                <>
                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-primary">How much premium do I have to pay?</h5>
                            <p>
                                The total premium amount you will have to pay depends on the sum insured and/or according to the plan you select.
                                Minimum of RM60.00 is applicable to the Section 1 (Houseowner) and Section 2 (Householder) total premium.
                                Premium Payment can be made via Cash, Credit Card, Internet Banking and Cheque.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-primary">What are some of the key terms and conditions that I should be aware of?</h5>
                            <h6><span className='m-1'>a)</span>Importance of Disclosure</h6>
                            <p className='ms-4'>
                                Pursuant to Paragraph 5 of Schedule 9 of the Financial Services Act 2013, if you are applying for this Insurance
                                wholly for purposes unrelated to your trade, business or profession, you have a duty to take reasonable care not
                                to make a misrepresentation in answering the questions in the Proposal Form (or when you apply for this insurance).
                            </p>
                            <p className='ms-4'>
                                You must answer the questions fully and accurately.
                            </p>
                            <p className='ms-4'>
                                Failure to take reasonable care in answering the questions may result in avoidance of your contract of insurance,
                                refusal or reduction of your claim(s), change of terms or termination of your contract of insurance.
                            </p>
                            <p className='ms-4'>
                                The above duty of disclosure shall continue until the time your contract of insurance is entered into, varied or renewed with us.
                            </p>
                            <p className='ms-4'>
                                In addition to answering the questions in the Proposal Form (or when you apply for this insurance), you are required to disclose any other matter that you know to be relevant to our decision in accepting the risks and determining the rates and terms to be applied.
                            </p>
                            <p className='ms-4'>
                                You also have a duty to tell us immediately if at any time after your contract of insurance has been entered into, varied or renewed with us any of the information given in the Proposal Form (or when you applied for this insurance) is inaccurate or has changed.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>b)</span>Duty of Assured</h6>
                            <p className='ms-4'>
                                You should take all reasonable precautions to prevent claim incidents.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>c)</span>Premium Warranty</h6>
                            <p className='ms-4'>
                                You must pay the premium and the premium must be received by the insurer within sixty (60) days from the policy/ endorsement/renewal certificate inception date.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>d)</span>Submission of Claim</h6>
                            <p className='ms-4'>
                                In the event of a claim, you are required to notify us within thirty (30) days from the date of the accident and submit the relevant documents within fourteen (14) days thereof
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>e)</span>Insured Value/Sum Insured</h6>
                            <p className='ms-4'>
                                You must ensure that your property is insured at the appropriate amount taking into account the renovations made to your property. If the amount insured in your policy is less than the actual value at the time of loss (i.e. under-insurance), you are deemed to be self-insuring the difference. This average condition will apply in the event of a claim.
                            </p>
                            <p className='ms-4'>
                                You may use the PIAM Building Cost Calculator (BCC) to guide you in determining the Sum Insured for your residential properties. You may access the BCC via our website at www.tuneprotect.com or PIAM�s website at www.piam.org.my.
                            </p>
                            <p className='ms-4'>
                                Excesses, being the amount you have to bear before we indemnify you, are applicable for certain perils, such as overflowing of domestic water tanks, windstorm, earthquake and flood claims.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h6><span className='m-1'>f)</span>Policy Expiry</h6>
                            <p className='ms-4'>
                                Unless renewed, coverage will cease upon policy expiry date.
                                (Note: Please refer to the policy wording for the full terms and conditions of this policy.)
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-primary">What are the major exclusions under this policy?</h5>
                            <p>This policy does not cover certain losses such as:</p>
                            <ul>
                                <li>Loss / damage due to subsidence, landslip, riot, strike and malicious damage: unless with additional premium</li>
                                <li>War, Civil War and any Act of Terrorism</li>
                                <li>Radioactive and Nuclear Energy Risks</li>
                                <li>Date recognition</li>
                                <li>Property Damage to data or software</li>
                                <li>Loss of damage by burst pipes whilst the building is untenanted</li>
                            </ul>
                            <p>(Note: This list is non-exhaustive. Please refer to the policy contract for the full list of exclusions under this policy.)</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-primary">Can I cancel my policy?</h5>
                            <p>You may cancel your policy at any time by giving written notice to us in which case we shall retain the customary short period rate for the time the policy has been in force. Upon cancellation, you are entitled to a refund premium subject to the minimum premium to be retained by the company. No refund of premium will be allowed if there is a claim under the policy.</p>
                        </div>
                    </div>
                </>
            );
        } else {
            return null;
        }
    }

    return (
        planPremium.length > 0 ?
            <Form onSubmit={(e) => onClickNext(e)}>
                <div className="mb-3 row justify-content-around">
                    {planPremium.map((plan, index) => (
                        <div className="col-11 border shadow m-3 rounded">
                            <div className="row">
                                <div className="col-12">
                                    <div className="row p-3">
                                        <div className="col-12 col-sm-7 text-center align-self-center">
                                            <p className="text-primary">{getBrand(plan.Insurer) + " " + plan.Plan_name.toUpperCase()}</p>
                                            <img src={"../images/" + plan.Insurer.toLowerCase() + ".png"} alt={plan.Insurer} className="img-fluid" width={150} />
                                        </div>
                                        <div className="col-12 col-sm-5 text-center align-self-center">
                                            <div className="row">
                                                <div className="col-12 px-0">
                                                    <p>Basic Premium</p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 px-0">
                                                    <div className="alert alert-info" role="alert">You have selected {(props.basicInfo.protectType == "content") ? "Content Only" : (props.basicInfo.protectType == "building") ? "Building Only" : "Building and Content Only"}</div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-12 px-0">
                                                    <h4 className="fw-bold text-primary">
                                                        RM {(parseFloat(plan.Premiumbuilding) + parseFloat(plan.Premiumcontent)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </h4>
                                                    <small>(not including 8% ST and Stamp Duty)</small>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-12 px-0">
                                                    <Button
                                                        variant={selectedPlan.Plan_name == plan.Plan_name ? 'info' : 'border border-primary'}
                                                        className="px-2 px-sm-5"
                                                        value={JSON.stringify(plan)}
                                                        onClick={(e) => { props.setComparisonInfo(JSON.parse(e.currentTarget.value)); props.setActiveId("addtl"); }}
                                                    >
                                                        Select
                                                    </Button>
                                                </div>
                                                <div className="col-12 px-0">
                                                    <a href={"../storage/pdf/PDS_" + plan.Insurer + ".pdf"} className="text-decoration-primary" target="_blank">
                                                        Product Disclosure Sheet
                                                    </a>
                                                </div>
                                                <div className="col-12 px-0">
                                                    <a href={"../storage/pdf/" + plan.Insurer + ".pdf"} className="text-decoration-primary" target="_blank">
                                                        Product Brochure
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 px-0">
                                    <Accordion>
                                        <Card className="rounded-bottom">
                                            <div className="row">
                                                <div className="col-4 pe-0">
                                                    <AccordionToggle
                                                        as={Card.Header}
                                                        eventKey={plan.Plan_name + index + ' ovr'}
                                                        className={
                                                            activeEventKey === plan.Plan_name + index + ' ovr' ?
                                                                'bg-primary text-center text-white h-100 border clickable' :
                                                                'text-center text-dark h-100 border clickable'
                                                        }
                                                        onClick={() => { setActiveEventKey(activeEventKey === plan.Plan_name + index + ' ovr' ? '' : plan.Plan_name + index + ' ovr') }}
                                                    >
                                                        <span className="clickable">Overview</span>
                                                    </AccordionToggle>
                                                </div>
                                                <div className="col-4 pe-0 ps-0 border-start">
                                                    <AccordionToggle
                                                        as={Card.Header}
                                                        eventKey={plan.Plan_name + index + ' pd'}
                                                        className={
                                                            activeEventKey === plan.Plan_name + index + ' pd' ?
                                                                'bg-primary text-center text-white h-100  clickable' :
                                                                'text-center text-dark h-100 clickable'
                                                        }
                                                        onClick={() => { setActiveEventKey(activeEventKey === plan.Plan_name + index + ' pd' ? '' : plan.Plan_name + index + ' pd') }}
                                                    >
                                                        <span className="clickable">Policy Details</span>
                                                    </AccordionToggle>
                                                </div>
                                                {/* <div className="col-3 pe-0 ps-0 border-start">
                                                    <AccordionToggle
                                                        as={Card.Header}
                                                        eventKey={plan.Plan_name + index + ' sb'}
                                                        className={
                                                            activeEventKey === plan.Plan_name + index + ' sb' ?
                                                                'bg-primary text-center text-white h-100  clickable' :
                                                                'text-center text-dark h-100 clickable'
                                                        }
                                                        onClick={() => { setActiveEventKey(activeEventKey === plan.Plan_name + index + ' sb' ? '' : plan.Plan_name + index + ' sb') }}
                                                    >
                                                        <span className="clickable">Schedule Of Benefits</span>
                                                    </AccordionToggle>
                                                </div> */}
                                                <div className="col-4 pe-0 ps-0 border-start">
                                                    <AccordionToggle
                                                        as={Card.Header}
                                                        eventKey={plan.Plan_name + index + ' faq'}
                                                        className={
                                                            activeEventKey === plan.Plan_name + index + ' faq' ?
                                                                'bg-primary text-center text-white h-100  clickable' :
                                                                'text-center text-dark h-100 clickable'
                                                        }
                                                        onClick={() => { setActiveEventKey(activeEventKey === plan.Plan_name + index + ' faq' ? '' : plan.Plan_name + index + ' faq') }}
                                                    >
                                                        <span className="clickable">FAQ</span>
                                                    </AccordionToggle>
                                                </div>
                                            </div>
                                            <AccordionCollapse eventKey={plan.Plan_name + index + ' ovr'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12 text-justify">
                                                            <Overview insurer={plan.Insurer} />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </AccordionCollapse>
                                            <AccordionCollapse eventKey={plan.Plan_name + index + ' pd'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12 text-justify">
                                                            <PolicyDetails insurer={plan.Insurer} />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </AccordionCollapse>
                                            {/* <AccordionCollapse eventKey={plan.Plan_name + index + ' sb'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12">

                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </AccordionCollapse> */}
                                            <AccordionCollapse eventKey={plan.Plan_name + index + ' faq'}>
                                                <Card.Body>
                                                    <div className="row">
                                                        <div className="col-12 text-justify">
                                                            <Faq insurer={plan.Insurer} />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </AccordionCollapse>
                                        </Card>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mb-3 row">
                    <div className="col-12 text-end">
                        <Button type="button" variant="secondary" className="me-3" onClick={() => { props.setActiveId('basic') }}>Back</Button>
                        {/* <Button type="submit" variant="success" disabled={isEmpty(selectedPlan) ? 'disabled' : ''}>Continue</Button> */}
                    </div>
                </div>
            </Form>
            :
            <>
                <div className="row">
                    <div className="col-12 text-center">
                        No Available Plans Found.
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-end">
                        <Button type="button" variant="secondary" className="me-3" onClick={() => { props.setActiveId('travel') }}>Back</Button>
                    </div>
                </div>
            </>
    );
}

function Additional(props) {
    const [activeId, setActiveId] = useState("");
    const [addtlCoverList, setAddtlCoverList] = useState([]);
    const [addtlCover, setAddtlCover] = useState([]);
    const [grossPrem, setGrossPrem] = useState(0);
    const [serviceTax, setServiceTax] = useState(0);
    const [stampDuty] = useState(10);
    const [totalAnnualPrem, setTotalAnnualPrem] = useState(0);
    const [propertyTypeLbl, setPropertyTypeLbl] = useState("");
    const swalAlert = withReactContent(Swal);

    var moneyFormatter = Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    useEffect(() => {
        if (props.basicInfo.protectType && props.basicInfo.bldgType) {
            setAddtlCover([]);
            setGrossPrem(0);
            setServiceTax(0);
            setTotalAnnualPrem(0);

            let basicProtectType = props.basicInfo.protectType;
            let basicBldgType = props.basicInfo.bldgType;
            let basicBldgAmt = !props.basicInfo.basicBldgAmt ? "0" : props.basicInfo.basicBldgAmt;
            let basicContentAmt = !props.basicInfo.basicContentAmt ? "0" : props.basicInfo.basicContentAmt;

            let protectType = "";
            if (basicProtectType == "content"  && basicBldgType == "landed") {
                setPropertyTypeLbl("Content Only");
                protectType = "C";
            } else if (basicProtectType == "content" && basicBldgType == "non-landed") {
                setPropertyTypeLbl("Content Only");
                protectType = "CX";
            } else if (basicProtectType == "building&content" && basicBldgType == "landed") {
                setPropertyTypeLbl("Building and Content");
                protectType = "CL";
            }
            else if (basicProtectType == "building&content" && basicBldgType == "non-landed") {
                setPropertyTypeLbl("Building and Content");
                protectType = "CNL";
            }
            else if (basicProtectType == "building" && basicBldgType == "landed") {
                setPropertyTypeLbl("Building Only");
                protectType = "L";
            }
            else if (basicProtectType == "building" && basicBldgType == "non-landed") {
                setPropertyTypeLbl("Building Only");
                protectType = "NL";
            }

            axios.get('/api/addtlcovers/' + protectType + '/' + basicBldgAmt + '/' + basicContentAmt)
                .then(response => {
                    let add_ons_list = response.data.filter((post) => {
                        return post.Insurer == props.comparisonInfo.Insurer;
                    });

                    add_ons_list.map((add_on) => {
                        if (add_on.Premium == 0) {
                            setAddtlCover([...addtlCover, add_on]);
                        }
                    });

                    setAddtlCoverList(add_ons_list);
                });
        }
    }, [props.basicInfo, props.comparisonInfo]);

    useEffect(() => {
        if (props.activeId === 'addtl') {
            swalAlert.fire({
                title: 'Please Wait...',
                allowOutsideClick: false
            });
            swalAlert.showLoading();

            if (addtlCoverList.length > 0) {
                swalAlert.close();
            }
        }

    }, [props.activeId, addtlCoverList])

    useEffect(() => {
        let totalBCPrem = parseFloat(props.comparisonInfo.Premiumbuilding) + parseFloat(props.comparisonInfo.Premiumcontent);
        let totalAdtlCover = 0;
        if (!isEmpty(addtlCover)) {
            addtlCover.map((add_on) => {
                if (add_on.benefits === 'Worldwide Personal All Risks' && document.getElementById('sum-insured-axa-worldwide').length > 0) {
                    add_on.Premium *= document.getElementById('sum-insured-axa-worldwide').text / 100;
                }
            });

            totalAdtlCover = addtlCover.reduce((prev, current) => {
                return prev + parseFloat(current.Premium);
            }, 0);
        }
        let totalCal = totalBCPrem + totalAdtlCover;
        console.log("total: " + totalCal );
        if(totalCal < 60){
            setGrossPrem(60);
        }else{
            setGrossPrem(totalBCPrem + totalAdtlCover);
        }
    }, [addtlCover, props.comparisonInfo.Premiumbuilding, props.comparisonInfo.Premiumcontent]);

    useEffect(() => {
        let tax = grossPrem * 0.08;
        setServiceTax(tax);
    }, [grossPrem]);

    useEffect(() => {
        let totAP = grossPrem + parseFloat(serviceTax) + stampDuty;
        setTotalAnnualPrem(totAP);
    }, [grossPrem, serviceTax]);

    function onClickNext(e) {
        e.preventDefault();
        e.stopPropagation();

        props.setAdditionalInfo({
            addtlCover: addtlCover,
            grossPrem: grossPrem,
            serviceTax: serviceTax,
            stampDuty: stampDuty,
            totalAnnualPrem: totalAnnualPrem
        });

        props.setActiveId("valuable");
    }

    const [checkbox1Checked, setCheckbox1Checked] = useState(false);
    const [checkbox2Checked, setCheckbox2Checked] = useState(false);
    const [checkbox3Checked, setCheckbox3Checked] = useState(false);
    const [checkbox4Checked, setCheckbox4Checked] = useState(false);
    function onCheckbox(e) {
        const parsedValue = JSON.parse(e.target.value);
        const isBenefitExcludingTheft = parsedValue.benefits.includes('Excluding Theft');
        const isBenefitIncludingTheft = parsedValue.benefits.includes('Including Theft');
        const isBenefitLimit100 = parsedValue.benefits.includes('Additional Limit- RM100,000.00');
        const isBenefitLimit200 = parsedValue.benefits.includes('Additional Limit- RM250,000.00');

        if (e.target.checked) {
            setAddtlCover((prevAddtlCover) => [
                ...prevAddtlCover,
                { ...parsedValue, disabled: false },
              ]);

            if (isBenefitExcludingTheft) {
                setCheckbox1Checked(true);
                setCheckbox2Checked(false); // Disable checkbox2 when checkbox1 is checked
            }

            if (isBenefitIncludingTheft) {
                setCheckbox2Checked(true);
                setCheckbox1Checked(false); // Disable checkbox1 when checkbox2 is checked
            }

            if (isBenefitLimit100) {
                setCheckbox3Checked(true);
                setCheckbox4Checked(false); // Disable checkbox2 when checkbox1 is checked
            }

            if (isBenefitLimit200) {
                setCheckbox4Checked(true);
                setCheckbox3Checked(false); // Disable checkbox1 when checkbox2 is checked
            }

        } else {
            let rows = [...addtlCover];
            var index = null;
            for (var i = 0; i < rows.length; i++) {
                if (rows[i].benefits === JSON.parse(e.target.value).benefits) {
                    index = i;
                    break;
                }
            }

            if (index !== null) {
                rows.splice(index, 1);
                setAddtlCover(rows);
            }

            if (isBenefitExcludingTheft) {
                setCheckbox1Checked(false);
                setCheckbox2Checked(false); // Disable checkbox2 when checkbox1 is checked
            }

            if (isBenefitIncludingTheft) {
                setCheckbox2Checked(false);
                setCheckbox1Checked(false); // Disable checkbox1 when checkbox2 is checked
            }

            if (isBenefitLimit100) {
                setCheckbox3Checked(false);
                setCheckbox4Checked(false); // Disable checkbox2 when checkbox1 is checked
            }

            if (isBenefitLimit200) {
                setCheckbox4Checked(false);
                setCheckbox3Checked(false); // Disable checkbox1 when checkbox2 is checked
            }

        }
    }

    return (
        totalAnnualPrem > 0 ?
            <Form onSubmit={(e) => onClickNext(e)}>
                <div className="row">
                    <div className="col-12">
                        <Alert variant="info" className="col-form-label fw-bolder">You have selected {propertyTypeLbl}</Alert>
                    </div>
                </div>
                <div className="mb-3 row">
                    <div className="col-lg-6 pricing">
                        <Sticky boundaryElement=".pricing">
                            <Card>
                                <Card.Header className="border-0">
                                    <div className="mb-3 row mb-0">
                                        <div className="col-12 text-center">
                                            <h5>{getInsurerFullName(props.comparisonInfo.Insurer)}</h5>
                                            <p className="mb-0">{props.comparisonInfo.Plan_name}</p>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="mb-3 row mt-3">
                                        <div className="col-12">
                                            <div className="row justify-content-around">
                                                <label className="col-12 col-sm-4 mb-sm-0">Covered From</label>
                                                <label className="col-12 d-sm-none">{Moment(props.basicInfo.basicStartDate).format('DD/MM/YYYY')}</label>
                                                <label className="col-12 col-sm-4 mb-sm-0 text-sm-end">Covered Till</label>
                                                <label className="col-12 d-sm-none">{Moment(props.basicInfo.basicEndDate).format('DD/MM/YYYY')}</label>
                                            </div>
                                            <div className="row justify-content-around d-none d-sm-flex">
                                                <label className="col-12 col-sm-4 mb-sm-0">{Moment(props.basicInfo.basicStartDate).format('DD/MM/YYYY')}</label>
                                                <label className="col-12 col-sm-4 mb-sm-0 text-end">{Moment(props.basicInfo.basicEndDate).format('DD/MM/YYYY')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-12">
                                            <Accordion activeKey={activeId}>
                                                <Card className="border-0">
                                                    <AccordionToggle as={Card.Header} eventKey="covType" onClick={() => { setActiveId("covType"); }} className="bg-transparent text-dark" >
                                                        Sum Insured {activeId === 'covType' ? <i className="fas fa-minus float-left mt-1 me-3"></i> : <i className="fas fa-plus float-left mt-1 me-3"></i>}
                                                    </AccordionToggle>

                                                    <AccordionCollapse eventKey="covType">
                                                        <Card.Body>
                                                            <div className="row">
                                                                <label className="col-12 col-sm-6">Building</label>
                                                                <label className="col-12 col-sm-6 text-end fw-bold">RM {moneyFormatter.format(props.basicInfo.basicBldgAmt)}</label>
                                                            </div>
                                                            <div className="row">
                                                                <label className="col-12 col-sm-6">Home Content</label>
                                                                <label className="col-12 col-sm-6 text-end fw-bold">RM {moneyFormatter.format(props.basicInfo.basicContentAmt)}</label>
                                                            </div>
                                                        </Card.Body>
                                                    </AccordionCollapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    </div>

                                    <div className="mb-3 row mb-0">
                                        <div className="col-12">
                                            <Accordion activeKey={activeId}>
                                                <Card className="border-0">
                                                    <AccordionToggle as={Card.Header} eventKey="totSI" onClick={() => { setActiveId("totSI"); }} className="bg-transparent text-dark" >
                                                        Total Premium Amount {activeId === 'totSI' ? <i className="fas fa-minus float-left mt-1 me-3"></i> : <i className="fas fa-plus float-left mt-1 me-3"></i>}
                                                        <label className="float-right">RM {moneyFormatter.format(totalAnnualPrem)}</label>
                                                    </AccordionToggle>

                                                    <AccordionCollapse eventKey="totSI">
                                                        <Card.Body>
                                                            <div className="row">
                                                                <label className="col-12 col-sm-6">Building</label>
                                                                <label className="col-12 col-sm-6 text-end fw-bold">RM {moneyFormatter.format(props.comparisonInfo.Premiumbuilding)}</label>
                                                            </div>
                                                            <div className="row">
                                                                <label className="col-12 col-sm-6">Home Content</label>
                                                                <label className="col-12 col-sm-6 text-end fw-bold">RM {moneyFormatter.format(props.comparisonInfo.Premiumcontent)}</label>
                                                            </div>

                                                            {isEmpty(addtlCover) ? "" :
                                                                <div className="row">
                                                                    <label className="col-12 fw-bold">Optional Extension selected</label>
                                                                    {addtlCover.map((acovers) => (
                                                                        <div className="ps-4 w-100">
                                                                            <label className="col-12 col-sm-6">{acovers.benefits}</label>
                                                                            <label className="col-12 col-sm-6 text-end">RM {moneyFormatter.format(acovers.Premium)}</label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            }
                                                        </Card.Body>
                                                    </AccordionCollapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    </div>
                                </Card.Body>
                                <Card.Footer className="bg-transparent border-0 pt-0">
                                    <div className="mb-3 row">
                                        <div className="col-12">
                                            <hr className="bg-primary" />
                                        </div>
                                        <div className="col-12">
                                            <label className="col-6">Gross Premium</label>
                                            <label className="col-6 text-end fw-bold">RM {moneyFormatter.format(grossPrem)}</label>
                                        </div>
                                        <div className="col-12">
                                            <label className="col-6">Service Tax  8% </label>
                                            <label className="col-6 text-end fw-bold">RM {moneyFormatter.format(serviceTax)}</label>
                                        </div>
                                        <div className="col-12">
                                            <label className="col-6">Stamp Duty</label>
                                            <label className="col-6 text-end fw-bold">RM {moneyFormatter.format(stampDuty)}</label>
                                        </div>
                                        <div className="col-12">
                                            <hr className="bg-primary" />
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-12 text-center">
                                            <label className="col-12 fw-bold">Total Annual Premium</label>
                                            <label className="col-12 text-primary fw-bold">RM {moneyFormatter.format(totalAnnualPrem)}</label>
                                        </div>
                                    </div>
                                    <div className="mb-3 row text-center">
                                        <div className="col-12 text-end">
                                            <Button type="button" variant="secondary" className="me-3" onClick={() => { props.setActiveId('quote') }}>Back</Button>
                                            <Button type="submit" variant="success">Continue</Button>
                                        </div>
                                    </div>
                                </Card.Footer>
                            </Card>
                        </Sticky>
                    </div>
                    <div className="col-lg-6">
                        <Card className="mx-auto mb-3 mb-sm-0">
                            <Card.Header>
                                <div className="mb-3 row mb-0">
                                    <div className="col-12 col-form-label fw-bolder text-center">
                                        <div className="row">
                                            <div className="col-12">
                                                Optional Extended Cover
                                            </div>
                                            <div className="col-12">
                                                <small>(with additional premium)</small>
                                            </div>
                                            <div className="col-12">
                                                <small>PLEASE TICK "/" FOR YOUR OPTIONAL COVER</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                {isEmpty(addtlCoverList) ?
                                    <div className="mb-3 row">
                                        <div className="col-12 col-form-label">No available Extended Cover</div>
                                    </div>
                                    : addtlCoverList.map((acover, index) => (
                                        acover.benefits !== 'Additional Limit- RM100,000.00' && acover.benefits !== "(i) Excluding Theft by Domestic Servant(s) or any member of the Insured's Family or Household or" ?
                                            <div className="mb-3 row" key={index}>
                                                <label className="col-11 col-form-label">
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`cb-${index}`}
                                                        label={acover.benefits}
                                                        /* defaultChecked={acover.Premium == 0} */
                                                        value={JSON.stringify(acover)}
                                                        onChange={(e) => onCheckbox(e)}
                                                        disabled={
                                                            (checkbox2Checked && acover.benefits.includes('Excluding Theft')) ||
                                                            (checkbox1Checked && acover.benefits.includes('Including Theft')) ||
                                                            (checkbox4Checked && acover.benefits.includes('Additional Limit- RM100,000.00')) ||
                                                            (checkbox3Checked && acover.benefits.includes('Additional Limit- RM250,000.00'))
                                                        }
                                                    />
                                                </label>
                                                <div className="col-1 col-form-label">
                                                {acover.description !== null ? (
                                                        <OverlayTrigger
                                                        trigger={['hover', 'click']}
                                                        key="o1"
                                                        placement="top"
                                                        overlay={
                                                            <Popover>
                                                            <Popover.Body>
                                                                {acover.description}
                                                            </Popover.Body>
                                                            </Popover>
                                                        }
                                                        >
                                                        <i className="fa fa-question-circle text-primary me-2" aria-hidden="true"></i>
                                                        </OverlayTrigger>
                                                    ) : null}
                                                </div>
                                            </div>
                                            :
                                            acover.benefits !== 'Additional Limit- RM100,000.00' && acover.benefits === "(i) Excluding Theft by Domestic Servant(s) or any member of the Insured's Family or Household or" ?
                                                <div className="mb-3 row" key={index}>
                                                    <div className="col-12 col-form-label">Extended Theft Cover</div>
                                                    <label className="col-11 col-form-label">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`cb-${index}`}
                                                            label={acover.benefits}
                                                            /* defaultChecked={acover.Premium == 0} */
                                                            value={JSON.stringify(acover)}
                                                            onChange={(e) => onCheckbox(e)}
                                                            disabled={
                                                                (checkbox2Checked && acover.benefits.includes('Excluding Theft')) ||
                                                                (checkbox1Checked && acover.benefits.includes('Including Theft')) ||
                                                                (checkbox4Checked && acover.benefits.includes('Additional Limit- RM100,000.00')) ||
                                                                (checkbox3Checked && acover.benefits.includes('Additional Limit- RM250,000.00'))
                                                            }
                                                        />
                                                    </label>
                                                    <div className="col-1 col-form-label">
                                                    {acover.description !== null ? (
                                                            <OverlayTrigger
                                                            trigger={['hover', 'click']}
                                                            key="o1"
                                                            placement="top"
                                                            overlay={
                                                                <Popover>
                                                                <Popover.Body>
                                                                    {acover.description}
                                                                </Popover.Body>
                                                                </Popover>
                                                            }
                                                            >
                                                            <i className="fa fa-question-circle text-primary me-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                :
                                                acover.benefits === 'Additional Limit- RM100,000.00' && acover.benefits !== "(i) Excluding Theft by Domestic Servant(s) or any member of the Insured's Family or Household or" ?
                                                <div className="mb-3 row" key={index}>
                                                    <div className="col-12 col-form-label">Increased Limit of Liability to Third Parties for Accidents in Your House</div>
                                                    <label className="col-11 col-form-label">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id={`cb-${index}`}
                                                            label={acover.benefits}
                                                            /* defaultChecked={acover.Premium == 0} */
                                                            value={JSON.stringify(acover)}
                                                            onChange={(e) => onCheckbox(e)}
                                                            disabled={
                                                                (checkbox2Checked && acover.benefits.includes('Excluding Theft')) ||
                                                                (checkbox1Checked && acover.benefits.includes('Including Theft')) ||
                                                                (checkbox4Checked && acover.benefits.includes('Additional Limit- RM100,000.00')) ||
                                                                (checkbox3Checked && acover.benefits.includes('Additional Limit- RM250,000.00'))
                                                            }
                                                        />
                                                    </label>
                                                    <div className="col-1 col-form-label">
                                                    {acover.description !== null ? (
                                                            <OverlayTrigger
                                                            trigger={['hover', 'click']}
                                                            key="o1"
                                                            placement="top"
                                                            overlay={
                                                                <Popover>
                                                                <Popover.Body>
                                                                    {acover.description}
                                                                </Popover.Body>
                                                                </Popover>
                                                            }
                                                            >
                                                            <i className="fa fa-question-circle text-primary me-2" aria-hidden="true"></i>
                                                            </OverlayTrigger>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                :
                                                <>
                                                    <div className="mb-3 row" key={index}>
                                                        <label className="col-sm-10 col-form-label">

                                                            <Form.Check
                                                                type="checkbox"
                                                                id={`cb-${index}`}
                                                                label={acover.benefits}
                                                                value={JSON.stringify(acover)}
                                                                checked={parseInt(acover.suminsured) > 0}
                                                                onChange={(e) => onCheckbox(e)}
                                                                disabled={parseInt(acover.suminsured) === 0 || acover.suminsured === undefined}
                                                            />
                                                        </label>
                                                    </div>
                                                    <div className="mb-3 row ps-3" key={index + '-si'}>
                                                        <div className="col-12 input-group">
                                                           
                                                             <CurrencyInput
                                                                id="sum-insured-axa-worldwide"
                                                                autoComplete="off"
                                                                allowNegativeValue={false}
                                                                decimalSeparator="."
                                                                groupSeparator=","
                                                                className="form-control"
                                                                decimalsLimit={2}
                                                                required
                                                                decimalScale={2}
                                                                placeholder="RM"
                                                                onValueChange={(value) => {
                                                                   setAddtlCoverList(addtlCoverList.map((add_ons) => (
                                                                        add_ons.benefits === 'Worldwide Personal All Risks' ? {
                                                                            Plan_name: add_ons.Plan_name,
                                                                            Insurer: add_ons.Insurer,
                                                                            benefits: add_ons.benefits,
                                                                            suminsured: value,
                                                                            Premium: value * (1.5 / 100)
                                                                        } : add_ons
                                                                    )))
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                    ))}
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </Form >
            :
            null
    );
}

function Valuable(props) {
    const [activeId, setActiveId] = useState("");
    const [eligible, setEligible] = useState(true);

    const [valGoldList, setValGoldList] = useState([]);
    const [valGoldItemID, setValGoldItemID] = useState(0);
    const [valGoldItemDesc, setValGoldItemDesc] = useState("");
    const [valGoldItemSI, setValGoldItemSI] = useState("");

    const [valJewelleryList, setValJewelleryList] = useState([]);
    const [valJewelleryItemID, setValJewelleryItemID] = useState(0);
    const [valJewelleryItemDesc, setValJewelleryItemDesc] = useState("");
    const [valJewelleryItemSI, setValJewelleryItemSI] = useState("");

    const [valSportsList, setValSportsList] = useState([]);
    const [valSportsItemID, setValSportsItemID] = useState(0);
    const [valSportsItemDesc, setValSportsItemDesc] = useState("");
    const [valSportsItemSI, setValSportsItemSI] = useState("");

    const [valCollectList, setValCollectList] = useState([]);
    const [valCollectItemID, setValCollectItemID] = useState(0);
    const [valCollectItemDesc, setValCollectItemDesc] = useState("");
    const [valCollectItemSI, setValCollectItemSI] = useState("");

    const [totalDeclared, setTotalDeclared] = useState(0);
    const [valuableEdit, setValuableEdit] = useState("");
    const swalAlert = withReactContent(Swal);

    var moneyFormatter = Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    useEffect(() => {
        let valTotal = 0;
        if (valGoldList.length > 0) {
            valTotal += valGoldList.reduce((tsig, sig) => tsig + parseFloat(sig.SumInsured), 0);
        }

        if (valJewelleryList.length > 0) {
            valTotal += valJewelleryList.reduce((tsij, sij) => tsij + parseFloat(sij.SumInsured), 0);
        }

        if (valSportsList.length > 0) {
            valTotal += valSportsList.reduce((tsis, sis) => tsis + parseFloat(sis.SumInsured), 0);
        }

        if (valCollectList.length > 0) {
            valTotal += valCollectList.reduce((tsic, sic) => tsic + parseFloat(sic.SumInsured), 0);
        }

        setTotalDeclared(valTotal);
    }, [valGoldList, valJewelleryList, valSportsList, valCollectList]);

    useEffect(() => {
        if (totalDeclared > (props.basicInfo.basictotalSI / 3)) {
            swalAlert.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Your valuables declared exceeded 1/3 of your total sum insured. Click \'OK\' to proceed to next page.',
                showCancelButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    document.getElementById('btn-continue').click();
                }
            })
        }
    }, [totalDeclared]);

    useEffect(() => {
        if (valuableEdit !== '') {
            let val = valuableEdit.split('_');
            var valCategory = val[0];
            var valID = val[1];
            var index = null;

            if (valCategory == "gold") {
                const objIndex = valGoldList.findIndex((obj => obj.ID == valID));
                setValGoldItemID(valGoldList[objIndex].ID);
                setValGoldItemDesc(valGoldList[objIndex].Description);
                setValGoldItemSI(valGoldList[objIndex].SumInsured);
            } else if (valCategory == "jewellery") {
                const objIndex = valJewelleryList.findIndex((obj => obj.ID == valID));
                setValJewelleryItemID(valJewelleryList[objIndex].ID);
                setValJewelleryItemDesc(valJewelleryList[objIndex].Description);
                setValJewelleryItemSI(valJewelleryList[objIndex].SumInsured);
            } else if (valCategory == "sports") {
                const objIndex = valSportsList.findIndex((obj => obj.ID == valID));
                setValSportsItemID(valSportsList[objIndex].ID);
                setValSportsItemDesc(valSportsList[objIndex].Description);
                setValSportsItemSI(valSportsList[objIndex].SumInsured);
            } else if (valCategory == "collect") {
                const objIndex = valCollectList.findIndex((obj => obj.ID == valID));
                setValCollectItemID(valCollectList[objIndex].ID);
                setValCollectItemDesc(valCollectList[objIndex].Description);
                setValCollectItemSI(valCollectList[objIndex].SumInsured);
            }
            //setValuableEdit("");
        }
    }, [valuableEdit])

    function onClickNext(e) {
        e.preventDefault();
        e.stopPropagation();

        props.setValuableInfo({
            valGoldList: valGoldList,
            valJewelleryList: valJewelleryList,
            valSportsList: valSportsList,
            valCollectList: valCollectList
        });

        props.setActiveId("personal");
    }

    function onTblAdd(e) {
        e.preventDefault();
        var valCategory = e.target.value;

        if (valCategory == "gold") {
            if (valGoldItemDesc == "" || valGoldItemSI == "" || valGoldItemSI == "0" || valGoldItemSI == undefined)
                swalAlert.fire({
                    title: 'Hmm...',
                    icon: 'warning',
                    text: 'Kindly fill in Item Description and Sum Insured.',
                });
            else {
                if (valGoldList.length == 20)
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'You\'ve reached the maximum of 20 items.',
                    });
                else {
                    if (valuableEdit !== "") {
                        let val = valuableEdit.split('_');
                        var valCategory = val[0];
                        var valID = val[1];
                        const objIndex = valGoldList.findIndex((obj => obj.ID == valID));
                        let newObjArray = ({
                            ID: valGoldList[objIndex].ID,
                            Description: valGoldItemDesc,
                            SumInsured: valGoldItemSI,
                            Category: "Gold"
                        });
                        const newArray = [...valGoldList];
                        newArray[objIndex] = newObjArray;
                        setValGoldList(newArray);
                        setValuableEdit("");
                    } else {
                        setValGoldList([...valGoldList, {
                            ID: Number(valGoldList.length === 0 ? "0" : valGoldList[valGoldList.length - 1].ID) + 1,
                            Description: valGoldItemDesc,
                            SumInsured: valGoldItemSI,
                            Category: "Gold"
                        }]);
                    }
                    setValGoldItemDesc("");
                    setValGoldItemSI("");
                }
            }
        } else if (valCategory == "jewellery") {
            if (valJewelleryItemDesc == "" || valJewelleryItemSI == "" || valJewelleryItemSI == "0" || valJewelleryItemSI == undefined)
                swalAlert.fire({
                    title: 'Hmm...',
                    icon: 'warning',
                    text: 'Kindly fill in Item Description and Sum Insured.',
                });
            else {
                if (valJewelleryList.length == 20)
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'You\'ve reached the maximum of 20 items.',
                    });
                else {
                    if (valuableEdit !== "") {
                        let val = valuableEdit.split('_');
                        var valCategory = val[0];
                        var valID = val[1];
                        const objIndex = valJewelleryList.findIndex((obj => obj.ID == valID));
                        let newObjArray = ({
                            ID: valJewelleryList[objIndex].ID,
                            Description: valJewelleryItemDesc,
                            SumInsured: valJewelleryItemSI,
                            Category: "Jewellery"
                        });
                        const newArray = [...valJewelleryList];
                        newArray[objIndex] = newObjArray;
                        setValJewelleryList(newArray);
                        setValuableEdit("");
                    } else {
                        setValJewelleryList([...valJewelleryList, {
                            ID: Number(valJewelleryList.length === 0 ? "0" : valJewelleryList[valJewelleryList.length - 1].ID) + 1,
                            Description: valJewelleryItemDesc,
                            SumInsured: valJewelleryItemSI,
                            Category: "Jewellery"
                        }]);
                    }
                    setValJewelleryItemDesc("");
                    setValJewelleryItemSI("");
                }
            }
        } else if (valCategory == "sports") {
            if (valSportsItemDesc == "" || valSportsItemSI == "" || valSportsItemSI == "0" || valSportsItemSI == undefined)
                swalAlert.fire({
                    title: 'Hmm...',
                    icon: 'warning',
                    text: 'Kindly fill in Item Description and Sum Insured.',
                });
            else {
                if (valSportsList.length == 20)
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'You\'ve reached the maximum of 20 items.',
                    });
                else {
                    if (valuableEdit !== "") {
                        let val = valuableEdit.split('_');
                        var valCategory = val[0];
                        var valID = val[1];
                        const objIndex = valSportsList.findIndex((obj => obj.ID == valID));
                        let newObjArray = ({
                            ID: valSportsList[objIndex].ID,
                            Description: valSportsItemDesc,
                            SumInsured: valSportsItemSI,
                            Category: "Sports"
                        });
                        const newArray = [...valSportsList];
                        newArray[objIndex] = newObjArray;
                        setValSportsList(newArray);
                        setValuableEdit("");
                    } else {
                        setValSportsList([...valSportsList, {
                            ID: Number(valSportsList.length === 0 ? "0" : valSportsList[valSportsList.length - 1].ID) + 1,
                            Description: valSportsItemDesc,
                            SumInsured: valSportsItemSI,
                            Category: "Sports"
                        }]);
                    }
                    setValSportsItemDesc("");
                    setValSportsItemSI("");
                }
            }
        } else if (valCategory == "collect") {
            if (valCollectItemDesc == "" || valCollectItemSI == "" || valCollectItemSI == "0" || valCollectItemSI == undefined)
                swalAlert.fire({
                    title: 'Hmm...',
                    icon: 'warning',
                    text: 'Kindly fill in Item Description and Sum Insured.',
                });
            else {
                if (valCollectList.length == 20)
                    swalAlert.fire({
                        title: 'Oops...',
                        icon: 'error',
                        text: 'You\'ve reached the maximum of 20 items.',
                    });
                else {
                    if (valuableEdit !== "") {
                        let val = valuableEdit.split('_');
                        var valCategory = val[0];
                        var valID = val[1];
                        const objIndex = valCollectList.findIndex((obj => obj.ID == valID));
                        let newObjArray = ({
                            ID: valCollectList[objIndex].ID,
                            Description: valCollectItemDesc,
                            SumInsured: valCollectItemSI,
                            Category: "Collectibles"
                        });
                        const newArray = [...valCollectList];
                        newArray[objIndex] = newObjArray;
                        setValCollectList(newArray);
                        setValuableEdit("");
                    } else {
                        setValCollectList([...valCollectList, {
                            ID: Number(valCollectList.length === 0 ? "0" : valCollectList[valCollectList.length - 1].ID) + 1,
                            Description: valCollectItemDesc,
                            SumInsured: valCollectItemSI,
                            Category: "Collectibles"
                        }]);
                    }
                    setValCollectItemDesc("");
                    setValCollectItemSI("");
                }
            }
        }
    }

    function handleDeleteRow(e) {
        e.preventDefault();
        let val = e.target.value.split('_');
        var valCategory = val[0];
        var valID = val[1];
        var index = null;

        if (valCategory == "gold") {
            let rows = [...valGoldList];

            for (var i = 0; i < rows.length; i++) {
                if (rows[i].ID === parseInt(valID)) {
                    index = i;
                    break;
                }
            }

            if (index !== -1) {
                rows.splice(index, 1);
                setValGoldList(rows);
            }
        } else if (valCategory == "jewellery") {
            let rows = [...valJewelleryList];

            for (var i = 0; i < rows.length; i++) {
                if (rows[i].ID === parseInt(valID)) {
                    index = i;
                    break;
                }
            }

            if (index !== -1) {
                rows.splice(index, 1);
                setValJewelleryList(rows);
            }
        } else if (valCategory == "sports") {
            let rows = [...valSportsList];

            for (var i = 0; i < rows.length; i++) {
                if (rows[i].ID === parseInt(valID)) {
                    index = i;
                    break;
                }
            }

            if (index !== -1) {
                rows.splice(index, 1);
                setValSportsList(rows);
            }
        } else if (valCategory == "collect") {
            let rows = [...valCollectList];

            for (var i = 0; i < rows.length; i++) {
                if (rows[i].ID === parseInt(valID)) {
                    index = i;
                    break;
                }
            }

            if (index !== -1) {
                rows.splice(index, 1);
                setValCollectList(rows);
            }
        }

        if (valuableEdit !== "") {
            setValuableEdit("");
        }
    }

    return (
        <Form>
            <div className="mb-3 row">
                <label className="col-12 col-form-label">We recommend to itemize your items if they are valued at RM 1,000 or more.</label>
            </div>
            <div className="mb-3 row">
                <div className="col-12">
                    <ul>
                        <li>No one article (furniture, pianos, organs, household appliances, radios, television sets, video recorder sets, Hi-Fi equipment not included) shall be of greater value than five (5) percent of the Total Sum Insured on Contents, unless such article is specially declared as a separate item.</li>
                        <li>The maximum claimable amount for platinum, gold silver, jewellery and furs should not exceed 1/3 of your total Home Contents Coverage.</li>
                    </ul>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-12">
                    <Table bordered hover responsive className="text-center">
                        <thead>
                            <tr>
                                <th>
                                    <div className="row">
                                        <div className="col-12">Maximum Amount</div>
                                        <div className="col-12 text-muted font-italic">
                                            <small>The total amount for Gold, Silver, Platinum, Jewellery, and Furs</small>
                                        </div>
                                    </div>
                                </th>
                                <th>Total Declared Amount</th>
                                <th>Undeclared Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="fw-bold">RM {moneyFormatter.format(props.basicInfo.basicContentAmt * (5/100))}</td>
                                <td className="fw-bold text-danger">- RM {moneyFormatter.format(totalDeclared)}</td>
                                <td className="fw-bold text-primary">RM {moneyFormatter.format((props.basicInfo.basicContentAmt * (5/100)) - totalDeclared)}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
            <div className="mb-3 row">
                <div className="col-12 mt-4">
                    <Accordion activeKey={activeId}>
                        <Card className="border border-bottom-grey">
                            <AccordionToggle as={Card.Header} eventKey="gold" onClick={() => { setActiveId("gold"); }} className="bg-transparent text-dark" >
                                Gold / Platinum / Silver {activeId === 'gold' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                            </AccordionToggle>

                            <AccordionCollapse eventKey="gold">
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <div className="col-12 col-form-label">
                                                    <Table bordered responsive>
                                                        <thead>
                                                            <tr>
                                                                <th>Item Description</th>
                                                                <th>Sum Insured</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {valGoldList.length == 0 ?
                                                                <tr><td colSpan="3" className="text-center">No Items added</td></tr> :
                                                                valGoldList.map((valGold, index) => (
                                                                    <tr key={index}>
                                                                        <td className="align-middle">{valGold.Description}</td>
                                                                        <td className="align-middle text-center">{moneyFormatter.format(valGold.SumInsured)}</td>
                                                                        <td className="align-middle text-center">
                                                                            <Button variant="warning" size="sm" className='me-2' onClick={(e) => setValuableEdit("gold_" + valGold.ID)}>Edit</Button>
                                                                            <Button variant="danger" size="sm" value={"gold_" + valGold.ID} onClick={(e) => handleDeleteRow(e)}>Delete</Button>
                                                                        </td> {/*  */}
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <div className="col-12 col-form-label">
                                                    <Card>
                                                        <Card.Header>Add/Edit more item(s)</Card.Header>
                                                        <Card.Body>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label">Item Description</label>
                                                                <div className="col-sm-7">
                                                                    <input type="text" className="form-control" value={valGoldItemDesc} onChange={(e) => setValGoldItemDesc(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label">Item Sum Insured</label>
                                                                <div className="col-sm-7">
                                                                   

                                                                    <CurrencyInput
                                                                id="contentAmt"
                                                                autoComplete="off"
                                                                allowNegativeValue={false}
                                                                decimalSeparator="."
                                                                groupSeparator=","
                                                                className="form-control"
                                                                decimalsLimit={2}
                                                                required
                                                                decimalScale={2}
                                                                placeholder="RM"
                                                                 value={valGoldItemSI}
                                                                onValueChange={(value) => {
                                                                  setValGoldItemSI(value)
                                                                     
                                                                }}
                                                            />
                                                                </div>
                                                            </div>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label"></label>
                                                                <div className="col-sm-7">
                                                                    <Button type="button" variant="info"  value="gold" onClick={(e) => onTblAdd(e)}>Save Item</Button>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>

                        <Card className="border border-bottom-grey mt-2">
                            <AccordionToggle as={Card.Header} eventKey="jewellery" onClick={() => { setActiveId("jewellery"); }} className="bg-transparent text-dark border-bottom" >
                                Jewellery and fur <br /> <small>(Diamond, Watches, necklace, bracelet, handbags…)</small> {activeId === 'jewellery' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                            </AccordionToggle>

                            <AccordionCollapse eventKey="jewellery">
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <div className="col-12 col-form-label">
                                                    <Table bordered responsive>
                                                        <thead>
                                                            <tr>
                                                                <th>Item Description</th>
                                                                <th>Sum Insured</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {valJewelleryList.length == 0 ?
                                                                <tr><td colSpan="3" className="text-center">No Items added</td></tr> :
                                                                valJewelleryList.map((valJewellery, index) => (
                                                                    <tr key={index}>
                                                                        <td className="align-middle">{valJewellery.Description}</td>
                                                                        <td className="align-middle text-center">{moneyFormatter.format(valJewellery.SumInsured)}</td>
                                                                        <td className="align-middle text-center">
                                                                            <Button variant="warning" size="sm" className='me-2' onClick={(e) => setValuableEdit("jewellery_" + valJewellery.ID)}>Edit</Button>
                                                                            <Button variant="danger" size="sm" value={"jewellery_" + valJewellery.ID} onClick={(e) => handleDeleteRow(e)}>Delete</Button>
                                                                        </td> {/*  */}
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <div className="col-12 col-form-label">
                                                    <Card>
                                                        <Card.Header>Add/Edit more item(s)</Card.Header>
                                                        <Card.Body>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label">Item Description</label>
                                                                <div className="col-sm-7">
                                                                    <input type="text" className="form-control" value={valJewelleryItemDesc} onChange={(e) => setValJewelleryItemDesc(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label">Item Sum Insured</label>
                                                                <div className="col-sm-7">
                                                                    

                                                                     <CurrencyInput
                                                                        id="contentAmt"
                                                                        autoComplete="off"
                                                                        allowNegativeValue={false}
                                                                        decimalSeparator="."
                                                                        groupSeparator=","
                                                                        className="form-control"
                                                                        decimalsLimit={2}
                                                                        required
                                                                        value={valJewelleryItemSI}
                                                                        decimalScale={2}
                                                                        placeholder="RM"
                                                                        onValueChange={(value) => {
                                                                            setValJewelleryItemSI(value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label"></label>
                                                                <div className="col-sm-7">
                                                                    <Button type="button" variant="info"  value="jewellery" onClick={(e) => onTblAdd(e)}>Save Item</Button>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>

                        <Card className="border border-bottom-grey mt-2">
                            <AccordionToggle as={Card.Header} eventKey="sports" onClick={() => { setActiveId("sports"); }} className="bg-transparent text-dark border-bottom" >
                                Sports <br /> <small>(Golf Sets, bicycles, gym sets…)</small> {activeId === 'sports' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                            </AccordionToggle>

                            <AccordionCollapse eventKey="sports">
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <div className="col-12 col-form-label">
                                                    <Table bordered responsive>
                                                        <thead>
                                                            <tr>
                                                                <th>Item Description</th>
                                                                <th>Sum Insured</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {valSportsList.length == 0 ?
                                                                <tr><td colSpan="3" className="text-center">No Items added</td></tr> :
                                                                valSportsList.map((valSports, index) => (
                                                                    <tr key={index}>
                                                                        <td className="align-middle">{valSports.Description}</td>
                                                                        <td className="align-middle text-center">{moneyFormatter.format(valSports.SumInsured)}</td>
                                                                        <td className="align-middle text-center">
                                                                            <Button variant="warning" size="sm" className='me-2' onClick={(e) => setValuableEdit("sports_" + valSports.ID)}>Edit</Button>
                                                                            <Button variant="danger" size="sm" value={"sports_" + valSports.ID} onClick={(e) => handleDeleteRow(e)}>Delete</Button>
                                                                        </td> {/*  */}
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <div className="col-12 col-form-label">
                                                    <Card>
                                                        <Card.Header>Add/Edit more item(s)</Card.Header>
                                                        <Card.Body>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label">Item Description</label>
                                                                <div className="col-sm-7">
                                                                    <input type="text" className="form-control" value={valSportsItemDesc} onChange={(e) => setValSportsItemDesc(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label">Item Sum Insured</label>
                                                                <div className="col-sm-7">
                                                                   

                                                                     <CurrencyInput
                                                                        id="contentAmt"
                                                                        autoComplete="off"
                                                                        allowNegativeValue={false}
                                                                        decimalSeparator="."
                                                                        groupSeparator=","
                                                                        className="form-control"
                                                                        decimalsLimit={2}
                                                                        required
                                                                        value={valSportsItemSI}
                                                                        decimalScale={2}
                                                                        placeholder="RM"
                                                                        onValueChange={(value) => {
                                                                            setValSportsItemSI(value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label"></label>
                                                                <div className="col-sm-7">
                                                                    <Button type="button" variant="info"  value="sports" onClick={(e) => onTblAdd(e)}>Save Item</Button>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>

                        <Card className="border border-bottom-grey mt-2">
                            <AccordionToggle as={Card.Header} eventKey="collect" onClick={() => { setActiveId("collect"); }} className="bg-transparent text-dark border-bottom" >
                                Collectibles <br /> <small>(Antiques, paintings…)</small> {activeId === 'collect' ? <i className="fas fa-caret-up float-right align-middle"></i> : <i className="fas fa-caret-down float-right align-middle"></i>}
                            </AccordionToggle>

                            <AccordionCollapse eventKey="collect">
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <div className="col-12 col-form-label">
                                                    <Table bordered responsive>
                                                        <thead>
                                                            <tr>
                                                                <th>Item Description</th>
                                                                <th>Sum Insured</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {valCollectList.length == 0 ?
                                                                <tr><td colSpan="3" className="text-center">No Items added</td></tr> :
                                                                valCollectList.map((valCollect, index) => (
                                                                    <tr key={index}>
                                                                        <td className="align-middle">{valCollect.Description}</td>
                                                                        <td className="align-middle text-center">{moneyFormatter.format(valCollect.SumInsured)}</td>
                                                                        <td className="align-middle text-center">
                                                                            <Button variant="warning" size="sm" className='me-2' onClick={(e) => setValuableEdit("collect_" + valCollect.ID)}>Edit</Button>
                                                                            <Button variant="danger" size="sm" value={"collect_" + valCollect.ID} onClick={(e) => handleDeleteRow(e)}>Delete</Button>
                                                                        </td> {/*  */}
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <div className="col-12 col-form-label">
                                                    <Card>
                                                        <Card.Header>Add/Edit more item(s)</Card.Header>
                                                        <Card.Body>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label">Item Description</label>
                                                                <div className="col-sm-7">
                                                                    <input type="text" className="form-control" value={valCollectItemDesc} onChange={(e) => setValCollectItemDesc(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label">Item Sum Insured</label>
                                                                <div className="col-sm-7">
                                                                    

                                                                     <CurrencyInput
                                                                        id="contentAmt"
                                                                        autoComplete="off"
                                                                        allowNegativeValue={false}
                                                                        decimalSeparator="."
                                                                        groupSeparator=","
                                                                        className="form-control"
                                                                        decimalsLimit={2}
                                                                        required
                                                                        value={valCollectItemSI}
                                                                        decimalScale={2}
                                                                        placeholder="RM"
                                                                        onValueChange={(value) => {
                                                                            setValCollectItemSI(value);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="mb-3 row">
                                                                <label className="col-sm-5 col-form-label"></label>
                                                                <div className="col-sm-7">
                                                                    <Button type="button" variant="info"  value="collect" onClick={(e) => onTblAdd(e)}>Save Item</Button>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </AccordionCollapse>
                        </Card>
                    </Accordion>
                </div>
            </div>
            <div className="mb-3 row justify-content-end">
                <div className="col-12 text-end">
                    <Button
                        type="button"
                        variant="secondary"
                        className="mb-3 mb-sm-0 me-3"
                        onClick={() => { props.setActiveId('addtl') }}
                    >
                        Back
                    </Button>
                    <Button
                        type="button"
                        variant="border border-warning"
                        className="mb-3 mb-sm-0 me-sm-3"
                        onClick={() => props.setActiveId("personal")}
                    >
                        I wish to skip
                    </Button>
                    <Button
                        type="submit"
                        variant="success"
                        id="btn-continue"
                        disabled={eligible ? '' : 'disabled'}
                        onClick={(e) => onClickNext(e)}
                    >
                        Continue
                    </Button>
                </div>
            </div>
        </Form>
    );
}

function Personal(props) {
    const [activeId, setActiveId] = useState("");
    const [fullName, setFullName] = useState("");
    const [IDType, setIDType] = useState("");
    const [IDNum, setIDNum] = useState("");
    const [nationality, setNationality] = useState("");
    const [birthDate, setBirthDate] = useState();
    const [mobileNo, setMobileNo] = useState("");
    const [emailAdd, setEmailAdd] = useState("");
    const [marital, setMarital] = useState("");
    const [occupation, setOccupation] = useState("");
    const [gender, setGender] = useState("");
    const [insuredAddress, setInsuredAddress] = useState("");
    const [mailAddress, setMailAddress] = useState("");
    const [sameInsuredMailAdd, setSameInsuredMailAdd] = useState("");
    const [IDTypeList] = useState([
        { value: "New IC No", label: "New IC No" },
        { value: "Passport", label: "Passport" },
        { value: "PR", label: "Permanent Resident" }
    ]);
    const swalAlert = withReactContent(Swal);

    var moneyFormatter = Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    useEffect(() => {
        setEmailAdd(props.basicInfo.basicEmailAdd);
        setMobileNo(props.basicInfo.basicContactNo);
        setFullName(props.basicInfo.basicName);
    }, [props.basicInfo, props.comparisonInfo, props.additionalInfo]);

    useEffect(() => {
        if (IDType == "New IC No") {
            setNationality("Malaysia")
        } else {
            setNationality("")
        }
    }, [IDType]);

    useEffect(() => {
        if (Math.abs(parseInt(Moment().diff(Moment(birthDate, 'DD/MM/YYYY'), 'days') / 365)) < 21) {
            swalAlert.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'You must be at least 21 years old to purchase this insurance. Please check the NRIC / Date of Birth details.',
            }).then((result) => {
                if (result.isConfirmed) {
                    setBirthDate("");
                    setIDNum("");
                    setNationality("");
                }
            });
        }
    }, [birthDate]);

    function onGetBrithDateAndGender(e) {
        var ic = e.target.value;
        setIDNum(ic);

        if (ic.match(/^(\d{2})([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])\d{2}\d{4}$/m)) {
            var [, year, month, day] = ic.match(/^(\d{2})([0][1-9]|[1][0-2])([0][1-9]|[1-2][0-9]|[3][0-1])\d{2}\d{4}$/m);
            var now = new Date().getFullYear().toString();

            if (now.substring(2) >= year) {
                year = parseInt(now.substring(0, 2).concat(year.toString()));
            } else {
                year = parseInt((now.substring(0, 2) - 1).toString().concat(year.toString()));
            }

            setBirthDate(new Date(year, (month - 1), day));
            setNationality("Malaysian");
            setIDType("New IC No");
            setGender(parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 == 0 ? 'Female' : 'Male');
        } else {
            setIDType("");
            setBirthDate("");
            setNationality("");
            setGender("");
        }
    }

    function onClickNext(e) {
        e.preventDefault();
        e.stopPropagation();

        props.setPersonalInfo({
            fullName: fullName,
            IDType: IDType,
            IDNum: IDNum,
            nationality: nationality,
            birthDate: birthDate,
            mobileNo: mobileNo,
            emailAdd: emailAdd,
            gender: gender,
            marital: marital,
            occupation: occupation,
            insuredAddress: insuredAddress,
            mailAddress: mailAddress
        });

        props.setActiveId('payment');
    }

    return (
        !isEmpty(props.basicInfo) && !isEmpty(props.comparisonInfo) && !isEmpty(props.additionalInfo) ?
            <Form onSubmit={(e) => onClickNext(e)}>
                <div className="mb-3 row">
                    <div className="col-lg-6 pricing">
                        <Sticky boundaryElement=".pricing">
                            <Card>
                                <Card.Header>
                                    <div className="mb-3 row mb-0">
                                        <div className="col-12 text-center">
                                            <h5>{getInsurerFullName(props.comparisonInfo.Insurer)}</h5>
                                            <p className="mb-0">{props.comparisonInfo.Plan_name}</p>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="mb-3 row mt-3">
                                        <div className="col-12">
                                            <div className="row justify-content-around">
                                                <label className="col-12 col-sm-4 mb-sm-0">Covered From</label>
                                                <label className="col-12 d-sm-none">{Moment(props.basicInfo.basicStartDate).format('DD/MM/YYYY')}</label>
                                                <label className="col-12 col-sm-4 mb-sm-0 text-sm-end">Covered Till</label>
                                                <label className="col-12 d-sm-none">{Moment(props.basicInfo.basicEndDate).format('DD/MM/YYYY')}</label>
                                            </div>
                                            <div className="row justify-content-around d-none d-sm-flex">
                                                <label className="col-12 col-sm-4 mb-sm-0">{Moment(props.basicInfo.basicStartDate).format('DD/MM/YYYY')}</label>
                                                <label className="col-12 col-sm-4 mb-sm-0 text-end">{Moment(props.basicInfo.basicEndDate).format('DD/MM/YYYY')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-12">
                                            <Accordion activeKey={activeId}>
                                                <Card className="border-0">
                                                    <AccordionToggle as={Card.Header} eventKey="covType" onClick={() => { setActiveId("covType"); }} className="bg-transparent text-dark" >
                                                        Sum Insured {activeId === 'covType' ? <i className="fas fa-minus float-left mt-1 me-3"></i> : <i className="fas fa-plus float-left mt-1 me-3"></i>}
                                                    </AccordionToggle>

                                                    <AccordionCollapse eventKey="covType">
                                                        <Card.Body>
                                                            <div className="row">
                                                                <label className="col-6">Building</label>
                                                                <label className="col-6 text-end fw-bold">RM {moneyFormatter.format(props.basicInfo.basicBldgAmt)}</label>
                                                            </div>
                                                            <div className="row">
                                                                <label className="col-6">Home Content</label>
                                                                <label className="col-6 text-end fw-bold">RM {moneyFormatter.format(props.basicInfo.basicContentAmt)}</label>
                                                            </div>
                                                        </Card.Body>
                                                    </AccordionCollapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    </div>

                                    <div className="mb-3 row">
                                        <div className="col-12">
                                            <Accordion activeKey={activeId}>
                                                <Card className="border-0">
                                                    <AccordionToggle as={Card.Header} eventKey="totSI" onClick={() => { setActiveId("totSI"); }} className="bg-transparent text-dark">
                                                        Total Premium Amount {activeId === 'totSI' ? <i className="fas fa-minus float-left mt-1 me-3"></i> : <i className="fas fa-plus float-left mt-1 me-3"></i>}
                                                        <label className="float-right">RM {moneyFormatter.format(props.additionalInfo.grossPrem)}</label>
                                                    </AccordionToggle>

                                                    <AccordionCollapse eventKey="totSI">
                                                        <Card.Body>
                                                            <div className="row">
                                                                <label className="col-6">Building</label>
                                                                <label className="col-6 text-end fw-bold">RM {moneyFormatter.format(props.comparisonInfo.Premiumbuilding)}</label>
                                                            </div>
                                                            <div className="row">
                                                                <label className="col-6">Home Content</label>
                                                                <label className="col-6 text-end fw-bold">RM {moneyFormatter.format(props.comparisonInfo.Premiumcontent)}</label>
                                                            </div>

                                                            {isEmpty(props.additionalInfo.addtlCover) ? "" :
                                                                <div className="row">
                                                                    <label className="col-12 fw-bold">Optional Extension selected</label>
                                                                    {props.additionalInfo.addtlCover.map((acovers) => (
                                                                        <div className="ps-4">
                                                                            <label className="col-6">{acovers.benefits}</label>
                                                                            <label className="col-6 text-end">RM {moneyFormatter.format(acovers.Premium)}</label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            }
                                                        </Card.Body>
                                                    </AccordionCollapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    </div>
                                </Card.Body>
                                <Card.Footer className="bg-transparent">
                                    <div className="mb-3 row">
                                        <hr className="bg-primary" />
                                        <div className="col-12">
                                            <label className="col-6">Gross Premium</label>
                                            <label className="col-6 text-end">
                                                RM {moneyFormatter.format(props.additionalInfo.grossPrem)}
                                            </label>
                                        </div>
                                        <div className="col-12">
                                            <label className="col-6">Service Tax 8%</label>
                                            <label className="col-6 text-end">RM {moneyFormatter.format(props.additionalInfo.serviceTax)}</label>
                                        </div>
                                        <div className="col-12">
                                            <label className="col-6">Stamp Duty</label>
                                            <label className="col-6 text-end">RM {moneyFormatter.format(props.additionalInfo.stampDuty)}</label>
                                        </div>
                                        <div className="col-12">
                                            <hr className="bg-primary" />
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-12 text-center">
                                            <label className="col-12 fw-bold">Total Annual Premium</label>
                                            <label className="col-12 text-primary fw-bold">RM {moneyFormatter.format(props.additionalInfo.totalAnnualPrem)}</label>
                                        </div>
                                    </div>
                                    <div className="mb-3 row text-center">
                                        <div className="col-12 text-end">
                                            <Button type="button" variant="secondary" className="me-3" onClick={() => { props.setActiveId('valuable') }}>Back</Button>
                                            <Button type="submit" variant="success">Continue</Button>
                                        </div>
                                    </div>
                                </Card.Footer>
                            </Card>
                        </Sticky>
                    </div>
                    <div className="col-lg-6 d-flex align-items-stretch">
                        <Card className="mx-auto">
                            <Card.Header className="border-0">
                                <div className="mb-3 row mb-0">
                                    <label className="col-12 col-form-label fw-bolder">Personal Details</label>
                                </div>
                            </Card.Header>
                            <Card.Body className="border-top-0">
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Full Name (as per NRIC)</label>
                                    <div className="col-12">
                                        <input type="text" className="form-control" required value={fullName} onChange={(e) => setFullName(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">ID Type</label>
                                    <div className="col-12">
                                        <Select
                                            styles={{
                                                control: provided => ({ ...provided, borderRadius: "2rem" })
                                            }}
                                            placeholder="Select ID type"
                                            value={IDTypeList.find(obj => obj.label === IDType)}
                                            options={IDTypeList}
                                            onChange={(e) => { setIDType(e.label); }}
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">ID Number</label>
                                    <div className="col-12">
                                        <input type="text" className="form-control" placeholder={IDType === 'New IC No' ? '87XXXXXXXXXX' : ''} required value={IDNum} onChange={(e) => onGetBrithDateAndGender(e)} />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Nationality</label>
                                    <div className="col-12">
                                        <input type="text" className="form-control" required value={nationality} onChange={(e) => setNationality(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Date of Birth</label>
                                    <div className="col-12">
                                        <DatePicker
                                            closeOnScroll={true}
                                            dateFormat="dd/MM/yyyy"
                                            className="form-control"
                                            placeholderText="DD/MM/YYYY"
                                            selected={birthDate}
                                            onChange={date => { setBirthDate(date); }}
                                            required
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Gender</label>
                                    <div className="col-12">
                                        <div className="mb-3 row">
                                            <div className="col-sm-6 d-grid">
                                                <Button
                                                    type="button"
                                                    variant={gender == "Male" ? "info" : "border border-primary"}
                                                    className="mb-3 mb-sm-0"
                                                    
                                                    onClick={() => { setGender("Male"); }}
                                                >
                                                    Male
                                                </Button>
                                            </div>
                                            <div className="col-sm-6 d-grid">
                                                <Button
                                                    type="button"
                                                    variant={gender == "Female" ? "info" : "border border-primary"}
                                                    className="mb-3 mb-sm-0"
                                                    
                                                    onClick={() => { setGender("Female"); }}
                                                >
                                                    Female
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Marital Status</label>
                                    <div className="col-12">
                                        <input type="text" className="form-control"  required value={marital} onChange={(e) => setMarital(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Occupation</label>
                                    <div className="col-12">
                                        <input type="text" className="form-control"  required value={occupation} onChange={(e) => setOccupation(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Mobile Number</label>
                                    <div className="col-12">
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            minLength={10}
                                            maxLength={11}
                                            value={mobileNo}
                                            onChange={(e) => setMobileNo(e.target.value)}
                                            pattern="\d*"
                                            placeholder="012xxxxxxxx"
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Email Address</label>
                                    <div className="col-12">
                                        <input type="email" className="form-control" placeholder='abc@gmail.com' required value={emailAdd} onChange={(e) => setEmailAdd(e.target.value)} />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Address of Property to be Insured</label>
                                    <div className="col-12">
                                        <textarea
                                            rows="5"
                                            cols="25"
                                            className="form-control"
                                            required
                                            placeholder="Full address including postcode & state"
                                            onChange={(e) => setInsuredAddress(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Is the above address your mailing address?</label>
                                    <div className="col-12">
                                        <div className="mb-3 row">
                                            <div className="col-sm-6 d-grid">
                                                <Button
                                                    type="button"
                                                    variant={sameInsuredMailAdd == "Yes" ? "info" : "border border-primary"}
                                                    className="mb-3 mb-sm-0"
                                                    
                                                    onClick={() => { setSameInsuredMailAdd("Yes"); setMailAddress(insuredAddress); }}
                                                >
                                                    Yes
                                                </Button>
                                            </div>
                                            <div className="col-sm-6 d-grid">
                                                <Button
                                                    type="button"
                                                    variant={sameInsuredMailAdd == "No" ? "info" : "border border-primary"}
                                                    className="mb-3 mb-sm-0"
                                                    
                                                    onClick={() => { setSameInsuredMailAdd("No"); setMailAddress(""); }}
                                                >
                                                    No
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label className="col-12 col-form-label">Mailing Address</label>
                                    <div className="col-12">
                                        <textarea
                                            rows="5"
                                            cols="25"
                                            className="form-control"
                                            required
                                            placeholder="Full address including postcode & state"
                                            value={mailAddress}
                                            onChange={(e) => setMailAddress(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </Form >
            :
            null
    );
}

function Payment(props) {
    let query = new URLSearchParams(useNavigate().search);
    const [transactionData, setTransactionData] = useState([]);
    const [transAdtlCoverData, setTransAdtlCoverData] = useState([]);
    const [transValuableData, setTransValuableData] = useState([]);
    const [transactionNo] = useState(Math.floor(new Date().getTime() / 1000));
    const [addOnPremium, setAddOnPremium] = useState(0);
    const [isGetSummary, setIsGetSummary] = useState(false);
    const [onSave, setOnSave] = useState(false);
    const [showDeclarationModal, setShowDeclarationModal] = useState(false);
    const [agreed, setAgreed] = useState("");
    const [files, setFiles] = useState([]);
    const swalAlert = withReactContent(Swal);
    const currentDate = new Date(); 
    const targetDate = new Date('2024-03-01');
    const shouldShowAlert = currentDate < targetDate;

    var moneyFormatter = Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    useEffect(() => {
        if (props.basicInfo.length !== 0 && props.claimInfo.length !== 0 &&
            props.comparisonInfo.length !== 0 && props.additionalInfo.length !== 0 &&
            props.personalInfo.length !== 0 && query.get("paymentID") === null) {
            setTransAdtlCoverData(props.additionalInfo.addtlCover);

            if (props.valuableInfo.length != 0) {
                let valuableList = [];
                if (props.valuableInfo.valCollectList.length > 0) {
                    props.valuableInfo.valCollectList.forEach(collect => {
                        valuableList.push(collect);
                    });
                }
                if (props.valuableInfo.valGoldList.length > 0) {
                    props.valuableInfo.valGoldList.forEach(gold => {
                        valuableList.push(gold);
                    });
                }
                if (props.valuableInfo.valJewelleryList.length > 0) {
                    props.valuableInfo.valJewelleryList.forEach(jewellery => {
                        valuableList.push(jewellery);
                    });
                }
                if (props.valuableInfo.valSportsList.length > 0) {
                    props.valuableInfo.valSportsList.forEach(sports => {
                        valuableList.push(sports);
                    });
                }

                setTransValuableData(valuableList);
            }

            setTransactionData({
                name: props.personalInfo.fullName,
                mobileNo: props.personalInfo.mobileNo,
                emailAdd: props.personalInfo.emailAdd,
                basicType: props.basicInfo.basicType,
                coverageFrom: props.basicInfo.basicStartDate,
                coverageTo: props.basicInfo.basicEndDate,
                constructionType: props.basicInfo.constType,
                buildingType: props.basicInfo.bldgType,
                noStoreys: props.basicInfo.basicStorey,
                protectType: props.basicInfo.protectType,
                //grossFloorArea: props.basicInfo.basicGrossArea,
                yearConstruction: props.basicInfo.basicYearCons,
                ageBuilding: props.basicInfo.basicAge,
                buildingSI: props.basicInfo.basicBldgAmt,
                contentSI: props.basicInfo.basicContentAmt,
                cBathAmt: props.basicInfo.basicCntBath,
                cBedRoomAmt: props.basicInfo.basicCntBedroom,
                cDiningAmt: props.basicInfo.basicCntDining,
                cGarageAmt: props.basicInfo.basicCntGarage,
                cKitchenAmt: props.basicInfo.basicCntKitchen,
                cLivingAmt: props.basicInfo.basicCntLiving,
                cMItemsAmt: props.basicInfo.basicCntMItems,
                cStoreAmt: props.basicInfo.basicCntStore,
                bcTotalSI: props.basicInfo.basictotalSI,
                pastClaim: props.claimInfo.claim,
                pastOccupancy: props.claimInfo.occupied,
                pastRejected: props.claimInfo.rejected,
                insurer: props.comparisonInfo.Insurer,
                planName: props.comparisonInfo.Plan_name,
                premiumbuilding: props.comparisonInfo.Premiumbuilding,
                premiumcontent: props.comparisonInfo.Premiumcontent,
                grossPremium: props.additionalInfo.grossPrem,
                serviceTax: props.additionalInfo.serviceTax,
                stampDuty: props.additionalInfo.stampDuty,
                totalAnnualPremium: props.additionalInfo.totalAnnualPrem,
                IDNum: props.personalInfo.IDNum,
                IDType: props.personalInfo.IDType,
                birthDate: Moment(props.personalInfo.birthDate).format("YYYY-MM-DD"),
                gender: props.personalInfo.gender,
                marital: props.personalInfo.marital,
                occupation: props.personalInfo.occupation,
                insuredAddress: props.personalInfo.insuredAddress,
                mailAddress: props.personalInfo.mailAddress,
                nationality: props.personalInfo.nationality,
                uploadedDoc: [],
                referral: props.referral,
                TransactionNo: transactionNo
            });
        } else if (query.get("paymentID") !== null) {
            axios.get('/api/order/' + query.get("paymentID"))
                .then(res => {
                    var trans = res.data[0]['trans'];
                    setTransactionData({
                        name: trans.name,
                        mobileNo: trans.mobileNo,
                        emailAdd: trans.emailAdd,
                        basicType: trans.basicType,
                        coverageFrom: trans.coverageFrom,
                        coverageTo: trans.coverageTo,
                        constructionType: trans.constructionType,
                        buildingType: trans.buildingType,
                        noStoreys: trans.noStoreys,
                        protectType: trans.protectType,
                        //grossFloorArea: trans.grossFloorArea,
                        yearConstruction: trans.yearConstruction,
                        ageBuilding: trans.ageBuilding,
                        buildingSI: trans.buildingSI,
                        contentSI: trans.contentSI,
                        cBathAmt: trans.basicCcBathAmtntBath,
                        cBedRoomAmt: trans.cBedRoomAmt,
                        cDiningAmt: trans.cDiningAmt,
                        cGarageAmt: trans.cGarageAmt,
                        cKitchenAmt: trans.cKitchenAmt,
                        cLivingAmt: trans.cLivingAmt,
                        cMItemsAmt: trans.cMItemsAmt,
                        cStoreAmt: trans.cStoreAmt,
                        bcTotalSI: trans.bcTotalSI,
                        pastClaim: trans.pastClaim,
                        pastOccupancy: trans.pastOccupancy,
                        pastRejected: trans.pastRejected,
                        insurer: trans.insurer,
                        planName: trans.planName,
                        premiumbuilding: trans.premiumbuilding,
                        premiumcontent: trans.premiumcontent,
                        grossPremium: trans.grossPremium,
                        serviceTax: trans.serviceTax,
                        stampDuty: trans.stampDuty,
                        totalAnnualPremium: trans.totalAnnualPremium,
                        IDNum: trans.IDNum,
                        IDType: trans.IDType,
                        birthDate: trans.birthDate,
                        gender: trans.gender,
                        marital: trans.marital,
                        occupation: trans.occupation,
                        insuredAddress: trans.insuredAddress,
                        mailAddress: trans.mailAddress,
                        nationality: trans.nationality,
                        referral: props.referral,
                        TransactionNo: trans.TransactionNo,
                        payment_status: trans.payment_status,
                        txn_message: trans.txn_message
                    });

                    let addtlCover = [];
                    res.data[0]['addtlCover'].map(ac => {
                        var obj = {
                            "Plan_name": ac.addtlcoverPlanName,
                            "benefits": ac.addtlcoverBenefits,
                            "Premium": ac.addtlcoverSI
                        };

                        addtlCover.push(obj);
                    });

                    setTransAdtlCoverData(addtlCover);
                    setIsGetSummary(true);
                })
        }
    }, [props.basicInfo, props.valuableInfo, props.claimInfo, props.comparisonInfo, props.additionalInfo, props.personalInfo]);

    useEffect(() => {
        if (transAdtlCoverData.length > 0) {
            setAddOnPremium(transAdtlCoverData.map((add_ons) => {
                return isNaN(parseFloat(add_ons.Premium)) ? 0 : parseFloat(add_ons.Premium);
            }).reduce((prev, current) => {
                return prev + current;
            }));
        }
    }, [transAdtlCoverData]);

    useEffect(() => {
        if (agreed === 'Agree') {
            if (onSave && !isEmpty(transactionData)) {
                setShowDeclarationModal(false);

                swalAlert.fire({
                    title: 'Please Wait...',
                    allowOutsideClick: false
                });
                swalAlert.showLoading();

                axios.post('/api/insert-payment', {
                    transaction_type: 'SALE',
                    payment_method: 'CC',
                    service_id: serviceID,
                    payment_id: transactionNo,
                    order_number: transactionNo,
                    payment_description: process.env.MIX_APP_NAME + " - " + transactionData.name,
                    amount: transactionData.total_payable,
                    currency_code: currencyCode,
                    hash: HashValue.toString()
                }).then(() => {
                    axios.post('/insert-transaction', {
                        transaction_data: transactionData,
                        valuables: transValuableData,
                        selected_add_ons: transAdtlCoverData,
                    })
                        .then(function (response) {
                            if (Number(transactionData.grossPremium) > 5000) {
                                let data = {
                                    name: transactionData.name,
                                    contact_no: transactionData.mobileNo,
                                    email_address: transactionData.emailAdd,
                                    is_owner: transactionData.basicType === "owner",
                                    building_type: transactionData.buildingType,
                                    protect_type: transactionData.protectType,
                                    number_of_storeys: transactionData.noStoreys,
                                    //gross_floor_area: transactionData.grossFloorArea,
                                    year_construction: transactionData.yearConstruction,
                                    age_building: transactionData.ageBuilding,
                                    building_amount: transactionData.buildingSI,
                                    content_amount: transactionData.contentSI,
                                    transactionNo: transactionData.TransactionNo
                                }

                                MoreThan5kCasesMail(data);
                            }
                            if (response.data.status) {
                                swalAlert.close();
                                document.getElementById('payment-form').submit();
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                });
            }
        }
    }, [onSave]);

    function PaymentSuccess() {
        return (<div className="alert alert-success" role="alert">
            {transactionData.txn_message}
        </div>);
    }

    function PaymentFail() {
        return (<div className="alert alert-danger" role="alert">
            {transactionData.txn_message}
        </div>);
    }

    function PaymentPending() {
        return (<div className="alert alert-warning" role="alert">
            Your Payment is still Pending.
        </div>);
    }

    function Message() {
        if (transactionData.payment_status == 'Pending') {
            return <PaymentPending />;
        } else if (transactionData.payment_status == 'Success') {
            return <PaymentSuccess />;
        } else if (transactionData.payment_status == 'Fail')
            return <PaymentFail />
        else return <></>
    }

    function DeclarationModal(props) {
        const [agree, setAgree] = useState("");
        const [error, setError] = useState(false);

        useEffect(() => {
            if (agree === 'Disagree') {
                setError(true);

                setTimeout(() => {
                    setError(false);
                }, 3000);
            } else {
                setError(false);
            }
        }, [agree]);

        return (
            <Modal show={props.showDeclarationModal} onHide={() => { props.setShowDeclarationModal(false); }} centered>
                <Modal.Header>
                    <Modal.Title>
                        <p className="mb-0">Confirmation</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>I, {props.insuredName}, confirm that:</p>
                    <p className="mt-3">
                        The policyholder acknowledges and understands their duty of utmost good faith and agrees to provide the insurer with all relevant and material information that may impact the insurer's assessment of risk and determination of premiums, including but not limited to any prior claims, known material facts, changes in circumstances, or any other information that a prudent insurer would reasonably consider important in assessing the risk and providing an accurate quote
                        {/* - I understand that it is my duty to take reasonable care not to make a misrepresentation in answering
                        the questions in this Application Form and I hereby declare that I have fully and accurately answered
                        the questions above. */}
                    </p>
                    <p className="mt-3">
                        - I have read, understood and accepted the <a href={getPDS(props.insurerName)} target="_blank" className="text-blue text-decoration-none">Product Disclosure Sheet</a>,  <a href={getPW(props.insurerName)} target="_blank" className="text-blue text-decoration-none">Policy Wordings</a> and
                        <a href={process.env.MIX_INSTAPOL_DOMAIN + '/privacy-policy'} target="_blank" className="text-blue text-decoration-none"> Privacy Notice</a> for this product. (These documents are available in digital format only. Please download and retain a copy for your future reference.)
                   </p>
                    <div className="mb-3 row">
                        <div className="col-sm-6 d-grid">
                            <Button
                                
                                type="radio"
                                variant={agree == "Agree" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                onClick={() => { setAgree("Agree"); }}
                            >
                                Agree
                            </Button>
                        </div>
                        <div className="col-sm-6 d-grid">
                            <Button
                                
                                type="radio"
                                variant={agree == "Disagree" ? "info" : "border border-primary"}
                                className="mb-3 mb-sm-0"
                                onClick={() => { setAgree("Disagree"); }}
                            >
                                Disagree
                            </Button>
                        </div>

                        {error ?
                            <p className="text-danger text-center fw-bold px-3 mt-2">
                                You have to agree to our terms in order to complete the transaction.
                            </p>
                            :
                            null
                        }
                    </div>
                    <p className="mt-3 fw-bold">
                        Please make sure you review the order and personal details before payment page
                    </p>
                    <p>Once you click 'Pay Now' you cannot change these details</p>
                    <p className="mt-4 d-none">
                        In the event that your proposal does not meet the requirement of Anti Money Laundering
                        and Sanction screening, this confirmation will be void <span className="font-italic">ab initio</span> and your premium will be
                        refunded accordingly by Howden Insurance Brokers Sdn Bhd.
                    </p>
			{props.insurerName === "LIBERTY" && (
    <p className="mt-4 text-muted small">
        This is a product made available for purchase on this platform. By proceeding with the services provided by Howden Insurance Brokers Sdn Bhd, the applicable commission will be charged. For a similar product, you may visit the Liberty Insurance website or any of Liberty's branches to enjoy a premium rebate.
    </p>
)}

                </Modal.Body>
                <Modal.Footer>
                    <div className="row">
                        <div className="col-12 text-end">
                            <Button variant="secondary" className="border-0 bg-transparent">Cancel</Button>
                            <Button variant="success" onClick={() => { props.setOnSave(agree === 'Agree'); props.setAgreed(agree) }}>Pay Now</Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }

    useEffect(() => {
        if (files.length !== 0) {
            setTransactionData({
                name: transactionData.name,
                mobileNo: transactionData.mobileNo,
                emailAdd: transactionData.emailAdd,
                basicType: transactionData.basicType,
                coverageFrom: transactionData.coverageFrom,
                coverageTo: transactionData.coverageTo,
                constructionType: transactionData.constructionType,
                buildingType: transactionData.buildingType,
                noStoreys: transactionData.noStoreys,
                protectType: transactionData.protectType,
                //grossFloorArea: transactionData.grossFloorArea,
                yearConstruction: transactionData.yearConstruction,
                ageBuilding: transactionData.ageBuilding,
                buildingSI: transactionData.buildingSI,
                contentSI: transactionData.contentSI,
                cBathAmt: transactionData.cBathAmt,
                cBedRoomAmt: transactionData.cBedRoomAmt,
                cDiningAmt: transactionData.cDiningAmt,
                cGarageAmt: transactionData.cGarageAmt,
                cKitchenAmt: transactionData.cKitchenAmt,
                cLivingAmt: transactionData.cLivingAmt,
                cMItemsAmt: transactionData.cMItemsAmt,
                cStoreAmt: transactionData.cStoreAmt,
                bcTotalSI: transactionData.bcTotalSI,
                pastClaim: transactionData.pastClaim,
                pastOccupancy: transactionData.pastOccupancy,
                pastRejected: transactionData.pastRejected,
                insurer: transactionData.insurer,
                planName: transactionData.planName,
                premiumbuilding: transactionData.premiumbuilding,
                premiumcontent: transactionData.premiumcontent,
                grossPremium: transactionData.grossPremium,
                serviceTax: transactionData.serviceTax,
                stampDuty: transactionData.stampDuty,
                totalAnnualPremium: transactionData.totalAnnualPremium,
                IDNum: transactionData.IDNum,
                IDType: transactionData.IDType,
                birthDate: transactionData.birthDate,
                gender: transactionData.gender,
                marital: transactionData.marital,
                occupation: transactionData.occupation,
                insuredAddress: transactionData.insuredAddress,
                mailAddress: transactionData.mailAddress,
                nationality: transactionData.nationality,
                uploadedDoc: [...transactionData.uploadedDoc, files],
                TransactionNo: transactionData.TransactionNo
            });
            console.log(transactionData)
        }
    }, [files])

    function uploadImage(e) {
        let file_reader = new FileReader();
        let file = e.target.files[0];
        let fileId = Number(transactionData.uploadedDoc.length === 0 ? 0 : transactionData.uploadedDoc[transactionData.uploadedDoc.length - 1].file_id) + 1;
        file_reader.onload = () => {
            setFiles({ file_id: fileId, file_name: file.name, file_type: file.type, uploaded_file: file_reader.result });
        };
        file_reader.readAsDataURL(file);

    }

    let serviceID = process.env.MIX_PAYMENT_GATEWAY_SERVICE_ID;
    let password = process.env.MIX_PAYMENT_GATEWAY_PASSWORD;
    let merchantReturnURL = process.env.MIX_APP_URL + "/api/store"; //"http://127.0.0.1:8092/api/store";
    let currencyCode = "MYR";
    let ip = process.env.MIX_APP_URL;
    let timeout = "600";
    let HashValue = SHA256(password + serviceID + transactionNo + merchantReturnURL + Number(transactionData.totalAnnualPremium).toFixed(2) + currencyCode + ip + timeout);

    return (
        <>
            {transactionData.length !== 0 ?
                <Form action={process.env.MIX_PAYMENT_GATEWAY_URL} method="POST" id="payment-form" >
                    <input type="hidden" name="TransactionType" value="SALE" />
                    <input type="hidden" name="PymtMethod" value="ANY" />
                    <input type="hidden" name="ServiceID" value={serviceID} />
                    <input type="hidden" name="PaymentID" value={transactionNo} />
                    <input type="hidden" name="OrderNumber" value={transactionNo} />
                    <input type="hidden" name="PaymentDesc" value={process.env.MIX_APP_NAME + ' - ' + transactionData.name + '(' + transactionNo + ')'} />
                    <input type="hidden" name="MerchantReturnURL" value={merchantReturnURL} />
                    <input type="hidden" name="Amount" value={Number(transactionData.totalAnnualPremium).toFixed(2)} />
                    <input type="hidden" name="CurrencyCode" value={currencyCode} />
                    <input type="hidden" name="CustName" value={transactionData.name} />
                    <input type="hidden" name="CustPhone" value={transactionData.mobileNo} />
                    <input type="hidden" name="CustEmail" value={transactionData.emailAdd} />
                    <input type="hidden" name="CustIP" value={ip} />
                    <input type="hidden" name="PageTimeout" value={timeout} />
                    <input type="hidden" name="LanguageCode" value="en" />
                    <input type="hidden" name="HashValue" value={HashValue} />
                    <div className="row">
                        <div className="col-12">
                            <div className="my-2">
                                {isGetSummary ? <Message /> : null}
                            </div>
                            <Card className="border rounded mb-4">
                                <Card.Header>
                                    <label className="fw-bold text-primary mb-0">Summary of Payment</label>
                                </Card.Header>
                                <Card.Body className="pb-0">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Product</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.planName}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Insurer</label>
                                                <label className="col-8 text-end fw-bold">{getInsurerFullName(transactionData.insurer)}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 align-top">Period of Insurance </label>
                                                <label className="col-6 text-end fw-bold">
                                                    {Moment(transactionData.coverageFrom).format('DD/MM/YYYY') + " to " + Moment(transactionData.coverageTo).format('DD/MM/YYYY')}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-12 col-form-label">Total Premium Amount</label>
                                                <div className="col-12">
                                                    <div className="row ps-4">
                                                        <label className="col-6">Building</label>
                                                        <label className="col-6 text-end fw-bold">
                                                            RM {moneyFormatter.format(transactionData.premiumbuilding)}
                                                        </label>
                                                    </div>
                                                    <div className="row ps-4">
                                                        <label className="col-6">Home Content</label>
                                                        <label className="col-6 text-end fw-bold">
                                                            RM {moneyFormatter.format(transactionData.premiumcontent)}
                                                        </label>
                                                    </div>

                                                    {isEmpty(transAdtlCoverData) ? "" :
                                                        <div className="row ps-4">
                                                            <label className="col-12">Add On Benefits</label>
                                                            <ol type="1" className="ps-5">
                                                                {transAdtlCoverData.map((acovers) => (
                                                                    <li>{acovers.benefits}</li>
                                                                ))}
                                                            </ol>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                                <Card.Footer className="bg-transparent border-0">
                                    <div className="mb-3 row">
                                        <div className="col-12">
                                            <div className="row border-top border-primary pt-4">
                                                <label className="col-6">Gross Premium</label>
                                                <label className="col-6 text-end">
                                                    RM {moneyFormatter.format(transactionData.grossPremium - addOnPremium)}
                                                </label>
                                            </div>
                                            <div className="row">
                                                <label className="col-6">Add On Benefits</label>
                                                <label className="col-6 text-end">
                                                    RM {moneyFormatter.format(addOnPremium)}
                                                </label>
                                            </div>
                                            <div className="row">
                                                <label className="col-6">Service Tax 8%</label>
                                                <label className="col-6 text-end">RM {moneyFormatter.format(transactionData.serviceTax)}</label>
                                            </div>
                                            <div className="row border-bottom border-primary pb-4">
                                                <label className="col-6">Stamp Duty</label>
                                                <label className="col-6 text-end">RM {moneyFormatter.format(transactionData.stampDuty)}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-3 row mb-0">
                                        <label className="col-6 fw-bold">Total Annual Premium</label>
                                        <label className="col-6 text-end text-primary fw-bold">RM {moneyFormatter.format(transactionData.totalAnnualPremium)}</label>
<label className='col-12 text-muted' style={{ 'font-size': '11px'}}>15% of commission amounting to RM {moneyFormatter.format((transactionData.grossPremium - addOnPremium) * 0.15 )} is payable to intermediary</label>
                                    </div>
                                </Card.Footer>
                            </Card>
                            <Card className="border rounded mb-4">
                                <Card.Header>
                                    <label className="fw-bold text-primary mb-0">Summary of Property to be Insured</label>
                                </Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12 col-sm-6">
                                            <div className="mb-3 row">
                                                <label className="col-6 align-top">Building Type</label>
                                                <label className="col-6 text-end fw-bold">{transactionData.buildingType.toUpperCase()}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 align-top">Construction Type</label>
                                                <label className="col-6 text-end fw-bold">{transactionData.constructionType}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 align-top">Number of Storey(s)</label>
                                                <label className="col-6 text-end fw-bold">{transactionData.noStoreys}</label>
                                            </div>
                                            {/* <div className="row">
                                                <label className="col-6 align-top">Gross Floor Area (in sq. ft.)</label>
                                                <label className="col-6 text-end fw-bold">{transactionData.grossFloorArea}</label>
                                            </div> */}
                                            <div className="row">
                                                <label className="col-6 align-top">Year of Construction</label>
                                                <label className="col-6 text-end fw-bold">{transactionData.yearConstruction}</label>
                                            </div>
                                            <div className="row">
                                                <label className="col-6 align-top">Age of Building</label>
                                                <label className="col-6 text-end fw-bold">{transactionData.ageBuilding}</label>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Coverage</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.protectType.toUpperCase().replace('&', ' & ')}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-12 align-top">Sum Insured Amount</label>
                                                <div className="col-12">
                                                    <div className="row ps-4">
                                                        <label className="col-4">Building</label>
                                                        <label className="col-8 text-end fw-bold">RM {moneyFormatter.format(transactionData.buildingSI)}</label>
                                                    </div>
                                                    <div className="row ps-4">
                                                        <label className="col-4">Content</label>
                                                        <label className="col-8 text-end fw-bold">RM {moneyFormatter.format(transactionData.contentSI)}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <label className="col-4 align-top">Address</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.insuredAddress}</label>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card className="border rounded">
                                <Card.Header>
                                    <label className="fw-bold text-primary mb-0">Summary of Insured Details</label>
                                </Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-12 col-sm-6">
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Full Name</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.name}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">ID Number</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.IDNum}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Gender</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.gender}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Marital Status</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.marital}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Occupation</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.occupation}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Date of Birth</label>
                                                <label className="col-8 text-end fw-bold">{Moment(transactionData.birthDate).format('DD/MM/YYYY')}</label>
                                            </div>
                                            <div className="row">
                                                <label className="col-4 align-top">Mobile Number</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.mobileNo}</label>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Nationality</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.nationality}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-4 align-top">Email Address</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.emailAdd}</label>
                                            </div>
                                            <div className="row">
                                                <label className="col-4 align-top">Mailing Address</label>
                                                <label className="col-8 text-end fw-bold">{transactionData.mailAddress}</label>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            {(Number(transactionData.grossPremium) > 5000) ?
                                <Card className="border rounded mt-3">
                                    <Card.Header>
                                        <label className="fw-bold text-primary mb-0">Additional Documents</label>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="mb-3 row">
                                                    <label className="col-4 align-top">Upload Document</label>
                                                    <input
                                                        type="file"
                                                        id={transactionData.transactionNo}
                                                        className="form-control col-8"
                                                        accept="pdf/*"
                                                        onChange={(e) => uploadImage(e)}
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3 row">
                                                    <div className='col-12'>
                                                        <ListGroup>
                                                            {
                                                                transactionData.uploadedDoc.map((f, i) => (
                                                                    <ListGroup.Item key={i}>{f.file_name}</ListGroup.Item>
                                                                ))
                                                            }
                                                        </ListGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                                : null}
                            <div className="mb-3 row mt-3">
                                <div className='col-lg-12'>
                                    {shouldShowAlert && (
                                        <div className="alert alert-danger" role="alert">
                                            Disclaimer: As announced by the government in the Budget 2024, <b>effective from 1st March 2024</b>, the adjustment of service tax from <b>6% to 8%</b> is applicable to all insurance services. Please be informed that any modifications or augmentation in service tax attributable to this revision is the responsibility of the insurance policy holder. The additional payable service tax is also applicable to any policy that is procured before 1st March 2024 but with a period of insurance spanning across 1st March 2024. Therefore, Howden Insurance Brokers Sdn Bhd reserves the right to collect any additional service tax on behalf of the Royal Malaysian Customs Department.
                                        </div>
                                    )}
                                </div>
                                <div className="col-12 text-end">
                                    <Button type="button" variant="secondary" className="me-3" onClick={() => { props.setActiveId('personal') }}>Back</Button>
                                    <Button
                                        type="button"
                                        variant="success"
                                        disabled={isGetSummary || (Number(transactionData.grossPremium) > 5000 && transactionData.uploadedDoc.length === 0) ? 'disabled' : ""}
                                        onClick={() => { setShowDeclarationModal(true) }}
                                    >
                                        Proceed to Pay RM {moneyFormatter.format(transactionData.totalAnnualPremium)}
                                    </Button>
                                    <DeclarationModal
                                        showDeclarationModal={showDeclarationModal} setShowDeclarationModal={setShowDeclarationModal} setAgreed={setAgreed}
                                        insuredName={transactionData.name} insurerName={transactionData.insurer} setOnSave={setOnSave}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
                :
                null
            }
        </>
    );
}

function rejectedCasesMail(data) {
    if (data.length !== 0) {
        axios.post('/api/send-rejected', {
            data: data
        }).then(function (response) {
            console.log(response);
        }).catch(function (error) {
            console.log(error);
        })
    }

    return (null);
}

function MoreThan5kCasesMail(data) {
    if (data.length !== 0) {
        axios.post('/api/morethan5k', {
            data: data
        }).then(function (response) {
            console.log(response);
        }).catch(function (error) {
            console.log(error);
        })
    }

    return (null);
}

function getInsurerFullName(short_name) {
    let full_name = '';

    if (short_name === 'MPIG') {
        full_name = 'MPI Generali Insurans Berhad';
    } else if (short_name === 'AXA') {
        full_name = 'AXA Affin General Insurance Berhad';
    } else if (short_name === 'MSIG') {
        full_name = 'MSIG Insurance (Malaysia) Berhad';
    } else if (short_name === 'TUNE') {
        full_name = 'TUNE INSURANCE BERHAD';
    } else if (short_name === 'LIBERTY') {
        full_name = 'LIBERTY GENERAL INSURANCE BERHAD';
    }

    return full_name;
}

function getBrand(short_name) {
    let full_name = '';

    if (short_name === 'MPIG') {
        full_name = 'Generali';
    } else if (short_name === 'AXA') {
        full_name = 'AXA Affin';
    } else if (short_name === 'MSIG') {
        full_name = 'MSIG';
    } else if (short_name === 'TUNE') {
        full_name = 'TUNE PROTECT';
    } else if (short_name === 'LIBERTY') {
        full_name = 'LIBERTY INSURANCE'; 
    }

    return full_name;
}

function getPDS(short_name) {
    let full_name = '';

    if (short_name === 'MPIG') {
        full_name = '';
    } else if (short_name === 'AXA') {
        full_name = '';
    } else if (short_name === 'MSIG') {
        full_name = '';
    } else if (short_name === 'TUNE') {
        full_name = 'storage/pdf/Tune Protect Home Shield (Product Disclosure Sheet).pdf';
    } else if (short_name === 'LIBERTY') {
        full_name = 'storage/pdf/PDS_LIBERTY.pdf';
    }

    return full_name;
}

function getPW(short_name) {
    let full_name = '';

    if (short_name === 'MPIG') {
        full_name = '';
    } else if (short_name === 'AXA') {
        full_name = '';
    } else if (short_name === 'MSIG') {
        full_name = '';
    } else if (short_name === 'TUNE') {
        full_name = 'storage/pdf/Tune Protect Home Shield (Policy Wordings).pdf';
    } else if (short_name === 'LIBERTY') {
        full_name = 'storage/pdf/LIBERTY.pdf';
    }

    return full_name;
}